import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import { print } from 'graphql'
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _float8: any;
  _int4: any;
  _varchar: any;
  bigint: any;
  float8: any;
  jsonb: any;
  timestamp: any;
  uuid: any;
};

/** expression to compare columns of type Boolean. All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** expression to compare columns of type Int. All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  _nlike?: InputMaybe<Scalars['String']>;
  _nsimilar?: InputMaybe<Scalars['String']>;
  _similar?: InputMaybe<Scalars['String']>;
};

/** expression to compare columns of type _float8. All fields are combined with logical 'AND'. */
export type _Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_float8']>;
  _gt?: InputMaybe<Scalars['_float8']>;
  _gte?: InputMaybe<Scalars['_float8']>;
  _in?: InputMaybe<Array<Scalars['_float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_float8']>;
  _lte?: InputMaybe<Scalars['_float8']>;
  _neq?: InputMaybe<Scalars['_float8']>;
  _nin?: InputMaybe<Array<Scalars['_float8']>>;
};

/** expression to compare columns of type _int4. All fields are combined with logical 'AND'. */
export type _Int4_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_int4']>;
  _gt?: InputMaybe<Scalars['_int4']>;
  _gte?: InputMaybe<Scalars['_int4']>;
  _in?: InputMaybe<Array<Scalars['_int4']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_int4']>;
  _lte?: InputMaybe<Scalars['_int4']>;
  _neq?: InputMaybe<Scalars['_int4']>;
  _nin?: InputMaybe<Array<Scalars['_int4']>>;
};

/** expression to compare columns of type _varchar. All fields are combined with logical 'AND'. */
export type _Varchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_varchar']>;
  _gt?: InputMaybe<Scalars['_varchar']>;
  _gte?: InputMaybe<Scalars['_varchar']>;
  _in?: InputMaybe<Array<Scalars['_varchar']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_varchar']>;
  _lte?: InputMaybe<Scalars['_varchar']>;
  _neq?: InputMaybe<Scalars['_varchar']>;
  _nin?: InputMaybe<Array<Scalars['_varchar']>>;
};

/** columns and relationships of "additional_info" */
export type Additional_Info = {
  __typename?: 'additional_info';
  condo?: Maybe<Scalars['Boolean']>;
  condoFeesPerYear?: Maybe<Scalars['Int']>;
  /** An object relationship */
  condoFeesPerYearCate?: Maybe<Condo_Fees_Per_Year>;
  constructionYear?: Maybe<Scalars['Int']>;
  coolingSystem?: Maybe<Scalars['String']>;
  energyPerformanceIndex?: Maybe<Scalars['Int']>;
  energyRating?: Maybe<Scalars['String']>;
  energyRatingCategory?: Maybe<Scalars['String']>;
  estateRegistryArea?: Maybe<Scalars['Int']>;
  estateRegistryClass?: Maybe<Scalars['String']>;
  exposure?: Maybe<Scalars['jsonb']>;
  furnishings?: Maybe<Scalars['String']>;
  glazing?: Maybe<Scalars['String']>;
  heatingSystem?: Maybe<Scalars['String']>;
  kitchen?: Maybe<Scalars['String']>;
  lastRenovationYear?: Maybe<Scalars['Int']>;
  stateAtDeed?: Maybe<Scalars['String']>;
  superCondo?: Maybe<Scalars['Boolean']>;
  views?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "additional_info" */
export type Additional_InfoExposureArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "additional_info" */
export type Additional_InfoViewsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "additional_info". All fields are combined with a logical 'AND'. */
export type Additional_Info_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Additional_Info_Bool_Exp>>>;
  _not?: InputMaybe<Additional_Info_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Additional_Info_Bool_Exp>>>;
  condo?: InputMaybe<Boolean_Comparison_Exp>;
  condoFeesPerYear?: InputMaybe<Int_Comparison_Exp>;
  condoFeesPerYearCate?: InputMaybe<Condo_Fees_Per_Year_Bool_Exp>;
  constructionYear?: InputMaybe<Int_Comparison_Exp>;
  coolingSystem?: InputMaybe<String_Comparison_Exp>;
  energyPerformanceIndex?: InputMaybe<Int_Comparison_Exp>;
  energyRating?: InputMaybe<String_Comparison_Exp>;
  energyRatingCategory?: InputMaybe<String_Comparison_Exp>;
  estateRegistryArea?: InputMaybe<Int_Comparison_Exp>;
  estateRegistryClass?: InputMaybe<String_Comparison_Exp>;
  exposure?: InputMaybe<Jsonb_Comparison_Exp>;
  furnishings?: InputMaybe<String_Comparison_Exp>;
  glazing?: InputMaybe<String_Comparison_Exp>;
  heatingSystem?: InputMaybe<String_Comparison_Exp>;
  kitchen?: InputMaybe<String_Comparison_Exp>;
  lastRenovationYear?: InputMaybe<Int_Comparison_Exp>;
  stateAtDeed?: InputMaybe<String_Comparison_Exp>;
  superCondo?: InputMaybe<Boolean_Comparison_Exp>;
  views?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** ordering options when selecting data from "additional_info" */
export type Additional_Info_Order_By = {
  condo?: InputMaybe<Order_By>;
  condoFeesPerYear?: InputMaybe<Order_By>;
  condoFeesPerYearCate?: InputMaybe<Condo_Fees_Per_Year_Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  coolingSystem?: InputMaybe<Order_By>;
  energyPerformanceIndex?: InputMaybe<Order_By>;
  energyRating?: InputMaybe<Order_By>;
  energyRatingCategory?: InputMaybe<Order_By>;
  estateRegistryArea?: InputMaybe<Order_By>;
  estateRegistryClass?: InputMaybe<Order_By>;
  exposure?: InputMaybe<Order_By>;
  furnishings?: InputMaybe<Order_By>;
  glazing?: InputMaybe<Order_By>;
  heatingSystem?: InputMaybe<Order_By>;
  kitchen?: InputMaybe<Order_By>;
  lastRenovationYear?: InputMaybe<Order_By>;
  stateAtDeed?: InputMaybe<Order_By>;
  superCondo?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "additional_info" */
export type Additional_Info_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "additional_info" */
export enum Additional_Info_Select_Column {
  /** column name */
  Condo = 'condo',
  /** column name */
  CondoFeesPerYear = 'condoFeesPerYear',
  /** column name */
  ConstructionYear = 'constructionYear',
  /** column name */
  CoolingSystem = 'coolingSystem',
  /** column name */
  EnergyPerformanceIndex = 'energyPerformanceIndex',
  /** column name */
  EnergyRating = 'energyRating',
  /** column name */
  EnergyRatingCategory = 'energyRatingCategory',
  /** column name */
  EstateRegistryArea = 'estateRegistryArea',
  /** column name */
  EstateRegistryClass = 'estateRegistryClass',
  /** column name */
  Exposure = 'exposure',
  /** column name */
  Furnishings = 'furnishings',
  /** column name */
  Glazing = 'glazing',
  /** column name */
  HeatingSystem = 'heatingSystem',
  /** column name */
  Kitchen = 'kitchen',
  /** column name */
  LastRenovationYear = 'lastRenovationYear',
  /** column name */
  StateAtDeed = 'stateAtDeed',
  /** column name */
  SuperCondo = 'superCondo',
  /** column name */
  Views = 'views'
}

/** columns and relationships of "addresses" */
export type Addresses = {
  __typename?: 'addresses';
  street?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Addresses_Bool_Exp>>>;
  _not?: InputMaybe<Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Addresses_Bool_Exp>>>;
  street?: InputMaybe<String_Comparison_Exp>;
  streetNumber?: InputMaybe<String_Comparison_Exp>;
  zipCode?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "addresses" */
export type Addresses_Order_By = {
  street?: InputMaybe<Order_By>;
  streetNumber?: InputMaybe<Order_By>;
  zipCode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "addresses" */
export type Addresses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "addresses" */
export enum Addresses_Select_Column {
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'streetNumber',
  /** column name */
  ZipCode = 'zipCode'
}

/** columns and relationships of "balconies" */
export type Balconies = {
  __typename?: 'balconies';
  area?: Maybe<Scalars['Int']>;
  areas?: Maybe<Scalars['jsonb']>;
  counter?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "balconies" */
export type BalconiesAreasArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "balconies". All fields are combined with a logical 'AND'. */
export type Balconies_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Balconies_Bool_Exp>>>;
  _not?: InputMaybe<Balconies_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Balconies_Bool_Exp>>>;
  area?: InputMaybe<Int_Comparison_Exp>;
  areas?: InputMaybe<Jsonb_Comparison_Exp>;
  counter?: InputMaybe<Int_Comparison_Exp>;
};

/** ordering options when selecting data from "balconies" */
export type Balconies_Order_By = {
  area?: InputMaybe<Order_By>;
  areas?: InputMaybe<Order_By>;
  counter?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "balconies" */
export type Balconies_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "balconies" */
export enum Balconies_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  Areas = 'areas',
  /** column name */
  Counter = 'counter'
}

/** expression to compare columns of type bigint. All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "boxes" */
export type Boxes = {
  __typename?: 'boxes';
  area?: Maybe<Scalars['Int']>;
  areas?: Maybe<Scalars['jsonb']>;
  counter?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "boxes" */
export type BoxesAreasArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "boxes". All fields are combined with a logical 'AND'. */
export type Boxes_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Boxes_Bool_Exp>>>;
  _not?: InputMaybe<Boxes_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Boxes_Bool_Exp>>>;
  area?: InputMaybe<Int_Comparison_Exp>;
  areas?: InputMaybe<Jsonb_Comparison_Exp>;
  counter?: InputMaybe<Int_Comparison_Exp>;
};

/** ordering options when selecting data from "boxes" */
export type Boxes_Order_By = {
  area?: InputMaybe<Order_By>;
  areas?: InputMaybe<Order_By>;
  counter?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "boxes" */
export type Boxes_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "boxes" */
export enum Boxes_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  Areas = 'areas',
  /** column name */
  Counter = 'counter'
}

/** columns and relationships of "characteristics" */
export type Characteristics = {
  __typename?: 'characteristics';
  /** An object relationship */
  balconies?: Maybe<Balconies>;
  bathrooms?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Scalars['Int']>;
  rooms?: Maybe<Scalars['Int']>;
  stateOfMaintenance?: Maybe<Scalars['String']>;
  /** An object relationship */
  terraces?: Maybe<Terraces>;
};

/** Boolean expression to filter rows from the table "characteristics". All fields are combined with a logical 'AND'. */
export type Characteristics_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Characteristics_Bool_Exp>>>;
  _not?: InputMaybe<Characteristics_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Characteristics_Bool_Exp>>>;
  balconies?: InputMaybe<Balconies_Bool_Exp>;
  bathrooms?: InputMaybe<Int_Comparison_Exp>;
  bedrooms?: InputMaybe<Int_Comparison_Exp>;
  rooms?: InputMaybe<Int_Comparison_Exp>;
  stateOfMaintenance?: InputMaybe<String_Comparison_Exp>;
  terraces?: InputMaybe<Terraces_Bool_Exp>;
};

/** ordering options when selecting data from "characteristics" */
export type Characteristics_Order_By = {
  balconies?: InputMaybe<Balconies_Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  bedrooms?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  stateOfMaintenance?: InputMaybe<Order_By>;
  terraces?: InputMaybe<Terraces_Order_By>;
};

/** primary key columns input for table: "characteristics" */
export type Characteristics_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "characteristics" */
export enum Characteristics_Select_Column {
  /** column name */
  Bathrooms = 'bathrooms',
  /** column name */
  Bedrooms = 'bedrooms',
  /** column name */
  Rooms = 'rooms',
  /** column name */
  StateOfMaintenance = 'stateOfMaintenance'
}

/** columns and relationships of "cities" */
export type Cities = {
  __typename?: 'cities';
  abbreviation?: Maybe<Scalars['String']>;
  center?: Maybe<Scalars['_float8']>;
  /** An array relationship */
  city_zones: Array<City_Zones>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  referenceArea?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** An array relationship */
  translations: Array<Translations>;
};


/** columns and relationships of "cities" */
export type CitiesCity_ZonesArgs = {
  distinct_on?: InputMaybe<Array<City_Zones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Zones_Order_By>>;
  where?: InputMaybe<City_Zones_Bool_Exp>;
};


/** columns and relationships of "cities" */
export type CitiesTranslationsArgs = {
  distinct_on?: InputMaybe<Array<Translations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Translations_Order_By>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "cities". All fields are combined with a logical 'AND'. */
export type Cities_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Cities_Bool_Exp>>>;
  _not?: InputMaybe<Cities_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Cities_Bool_Exp>>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  center?: InputMaybe<_Float8_Comparison_Exp>;
  city_zones?: InputMaybe<City_Zones_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  referenceArea?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<Translations_Bool_Exp>;
};

/** ordering options when selecting data from "cities" */
export type Cities_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  center?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  referenceArea?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "cities" */
export type Cities_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "cities" */
export enum Cities_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  Center = 'center',
  /** column name */
  Country = 'country',
  /** column name */
  Name = 'name',
  /** column name */
  ReferenceArea = 'referenceArea',
  /** column name */
  Slug = 'slug'
}

/** columns and relationships of "city_zones" */
export type City_Zones = {
  __typename?: 'city_zones';
  label?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "city_zones". All fields are combined with a logical 'AND'. */
export type City_Zones_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<City_Zones_Bool_Exp>>>;
  _not?: InputMaybe<City_Zones_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<City_Zones_Bool_Exp>>>;
  label?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "city_zones" */
export type City_Zones_Order_By = {
  label?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "city_zones" */
export type City_Zones_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "city_zones" */
export enum City_Zones_Select_Column {
  /** column name */
  Label = 'label',
  /** column name */
  Slug = 'slug'
}

/** columns and relationships of "condo_fees_per_year" */
export type Condo_Fees_Per_Year = {
  __typename?: 'condo_fees_per_year';
  cents?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "condo_fees_per_year". All fields are combined with a logical 'AND'. */
export type Condo_Fees_Per_Year_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Condo_Fees_Per_Year_Bool_Exp>>>;
  _not?: InputMaybe<Condo_Fees_Per_Year_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Condo_Fees_Per_Year_Bool_Exp>>>;
  cents?: InputMaybe<Int_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "condo_fees_per_year" */
export type Condo_Fees_Per_Year_Order_By = {
  cents?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "condo_fees_per_year" */
export type Condo_Fees_Per_Year_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "condo_fees_per_year" */
export enum Condo_Fees_Per_Year_Select_Column {
  /** column name */
  Cents = 'cents',
  /** column name */
  Currency = 'currency'
}

/** columns and relationships of "contact_info" */
export type Contact_Info = {
  __typename?: 'contact_info';
  agencyAddress?: Maybe<Scalars['String']>;
  agencyLogo?: Maybe<Scalars['String']>;
  agencyName?: Maybe<Scalars['String']>;
  agencyWebsite?: Maybe<Scalars['String']>;
  emailContact?: Maybe<Scalars['String']>;
  ownedByCasavo?: Maybe<Scalars['Boolean']>;
  telephoneNumberContact?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "contact_info". All fields are combined with a logical 'AND'. */
export type Contact_Info_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Contact_Info_Bool_Exp>>>;
  _not?: InputMaybe<Contact_Info_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Contact_Info_Bool_Exp>>>;
  agencyAddress?: InputMaybe<String_Comparison_Exp>;
  agencyLogo?: InputMaybe<String_Comparison_Exp>;
  agencyName?: InputMaybe<String_Comparison_Exp>;
  agencyWebsite?: InputMaybe<String_Comparison_Exp>;
  emailContact?: InputMaybe<String_Comparison_Exp>;
  ownedByCasavo?: InputMaybe<Boolean_Comparison_Exp>;
  telephoneNumberContact?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "contact_info" */
export type Contact_Info_Order_By = {
  agencyAddress?: InputMaybe<Order_By>;
  agencyLogo?: InputMaybe<Order_By>;
  agencyName?: InputMaybe<Order_By>;
  agencyWebsite?: InputMaybe<Order_By>;
  emailContact?: InputMaybe<Order_By>;
  ownedByCasavo?: InputMaybe<Order_By>;
  telephoneNumberContact?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "contact_info" */
export type Contact_Info_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "contact_info" */
export enum Contact_Info_Select_Column {
  /** column name */
  AgencyAddress = 'agencyAddress',
  /** column name */
  AgencyLogo = 'agencyLogo',
  /** column name */
  AgencyName = 'agencyName',
  /** column name */
  AgencyWebsite = 'agencyWebsite',
  /** column name */
  EmailContact = 'emailContact',
  /** column name */
  OwnedByCasavo = 'ownedByCasavo',
  /** column name */
  TelephoneNumberContact = 'telephoneNumberContact'
}

/** columns and relationships of "descriptions" */
export type Descriptions = {
  __typename?: 'descriptions';
  language?: Maybe<Scalars['String']>;
  neighbourhoodDescription?: Maybe<Scalars['String']>;
  propertyDescription?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "descriptions". All fields are combined with a logical 'AND'. */
export type Descriptions_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Descriptions_Bool_Exp>>>;
  _not?: InputMaybe<Descriptions_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Descriptions_Bool_Exp>>>;
  language?: InputMaybe<String_Comparison_Exp>;
  neighbourhoodDescription?: InputMaybe<String_Comparison_Exp>;
  propertyDescription?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "descriptions" */
export type Descriptions_Order_By = {
  language?: InputMaybe<Order_By>;
  neighbourhoodDescription?: InputMaybe<Order_By>;
  propertyDescription?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "descriptions" */
export type Descriptions_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "descriptions" */
export enum Descriptions_Select_Column {
  /** column name */
  Language = 'language',
  /** column name */
  NeighbourhoodDescription = 'neighbourhoodDescription',
  /** column name */
  PropertyDescription = 'propertyDescription'
}

/** columns and relationships of "detail" */
export type Detail = {
  __typename?: 'detail';
  buildingFloors?: Maybe<Scalars['Int']>;
  casavoDirectSale?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  commercialArea?: Maybe<Scalars['Int']>;
  entireBuilding?: Maybe<Scalars['Boolean']>;
  entranceFloor?: Maybe<Scalars['Int']>;
  exclusiveSellingMandate?: Maybe<Scalars['Boolean']>;
  floorPosition?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  floors: Array<Floors>;
  inventory: Scalars['String'];
  privateNegotiation?: Maybe<Scalars['Boolean']>;
  salesPipeline?: Maybe<Scalars['String']>;
  /** An object relationship */
  sellingPrices?: Maybe<Selling_Prices>;
  sellingUnitId?: Maybe<Scalars['String']>;
  /** An array relationship */
  titles: Array<Titles>;
  transactionId?: Maybe<Scalars['String']>;
  /** An object relationship */
  zone?: Maybe<Zones>;
};


/** columns and relationships of "detail" */
export type DetailFloorPositionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "detail" */
export type DetailFloorsArgs = {
  distinct_on?: InputMaybe<Array<Floors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Floors_Order_By>>;
  where?: InputMaybe<Floors_Bool_Exp>;
};


/** columns and relationships of "detail" */
export type DetailTitlesArgs = {
  distinct_on?: InputMaybe<Array<Titles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Titles_Order_By>>;
  where?: InputMaybe<Titles_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "detail". All fields are combined with a logical 'AND'. */
export type Detail_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Detail_Bool_Exp>>>;
  _not?: InputMaybe<Detail_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Detail_Bool_Exp>>>;
  buildingFloors?: InputMaybe<Int_Comparison_Exp>;
  casavoDirectSale?: InputMaybe<Boolean_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  commercialArea?: InputMaybe<Int_Comparison_Exp>;
  entireBuilding?: InputMaybe<Boolean_Comparison_Exp>;
  entranceFloor?: InputMaybe<Int_Comparison_Exp>;
  exclusiveSellingMandate?: InputMaybe<Boolean_Comparison_Exp>;
  floorPosition?: InputMaybe<Jsonb_Comparison_Exp>;
  floors?: InputMaybe<Floors_Bool_Exp>;
  inventory?: InputMaybe<String_Comparison_Exp>;
  privateNegotiation?: InputMaybe<Boolean_Comparison_Exp>;
  salesPipeline?: InputMaybe<String_Comparison_Exp>;
  sellingPrices?: InputMaybe<Selling_Prices_Bool_Exp>;
  sellingUnitId?: InputMaybe<String_Comparison_Exp>;
  titles?: InputMaybe<Titles_Bool_Exp>;
  transactionId?: InputMaybe<String_Comparison_Exp>;
  zone?: InputMaybe<Zones_Bool_Exp>;
};

/** ordering options when selecting data from "detail" */
export type Detail_Order_By = {
  buildingFloors?: InputMaybe<Order_By>;
  casavoDirectSale?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  entireBuilding?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  exclusiveSellingMandate?: InputMaybe<Order_By>;
  floorPosition?: InputMaybe<Order_By>;
  inventory?: InputMaybe<Order_By>;
  privateNegotiation?: InputMaybe<Order_By>;
  salesPipeline?: InputMaybe<Order_By>;
  sellingPrices?: InputMaybe<Selling_Prices_Order_By>;
  sellingUnitId?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
  zone?: InputMaybe<Zones_Order_By>;
};

/** primary key columns input for table: "detail" */
export type Detail_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "detail" */
export enum Detail_Select_Column {
  /** column name */
  BuildingFloors = 'buildingFloors',
  /** column name */
  CasavoDirectSale = 'casavoDirectSale',
  /** column name */
  City = 'city',
  /** column name */
  CommercialArea = 'commercialArea',
  /** column name */
  EntireBuilding = 'entireBuilding',
  /** column name */
  EntranceFloor = 'entranceFloor',
  /** column name */
  ExclusiveSellingMandate = 'exclusiveSellingMandate',
  /** column name */
  FloorPosition = 'floorPosition',
  /** column name */
  Inventory = 'inventory',
  /** column name */
  PrivateNegotiation = 'privateNegotiation',
  /** column name */
  SalesPipeline = 'salesPipeline',
  /** column name */
  SellingUnitId = 'sellingUnitId',
  /** column name */
  TransactionId = 'transactionId'
}

/** expression to compare columns of type float8. All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "floors" */
export type Floors = {
  __typename?: 'floors';
  buildingFloor?: Maybe<Scalars['Int']>;
  entireFloor?: Maybe<Scalars['Boolean']>;
  floorShift?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "floors". All fields are combined with a logical 'AND'. */
export type Floors_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Floors_Bool_Exp>>>;
  _not?: InputMaybe<Floors_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Floors_Bool_Exp>>>;
  buildingFloor?: InputMaybe<Int_Comparison_Exp>;
  entireFloor?: InputMaybe<Boolean_Comparison_Exp>;
  floorShift?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "floors" */
export type Floors_Order_By = {
  buildingFloor?: InputMaybe<Order_By>;
  entireFloor?: InputMaybe<Order_By>;
  floorShift?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "floors" */
export type Floors_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "floors" */
export enum Floors_Select_Column {
  /** column name */
  BuildingFloor = 'buildingFloor',
  /** column name */
  EntireFloor = 'entireFloor',
  /** column name */
  FloorShift = 'floorShift'
}

/** columns and relationships of "furnishing_proposals" */
export type Furnishing_Proposals = {
  __typename?: 'furnishing_proposals';
  price?: Maybe<Scalars['jsonb']>;
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "furnishing_proposals" */
export type Furnishing_ProposalsPriceArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "furnishing_proposals". All fields are combined with a logical 'AND'. */
export type Furnishing_Proposals_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Furnishing_Proposals_Bool_Exp>>>;
  _not?: InputMaybe<Furnishing_Proposals_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Furnishing_Proposals_Bool_Exp>>>;
  price?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "furnishing_proposals" */
export type Furnishing_Proposals_Order_By = {
  price?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "furnishing_proposals" */
export type Furnishing_Proposals_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "furnishing_proposals" */
export enum Furnishing_Proposals_Select_Column {
  /** column name */
  Price = 'price',
  /** column name */
  Url = 'url'
}

/** expression to compare columns of type jsonb. All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "listings_detail" */
export type Listings_Detail = {
  __typename?: 'listings_detail';
  /** An object relationship */
  additionalInfo?: Maybe<Additional_Info>;
  /** An object relationship */
  addressesCate?: Maybe<Addresses>;
  /** An object relationship */
  characteristics?: Maybe<Characteristics>;
  /** An object relationship */
  contactInfo?: Maybe<Contact_Info>;
  coordinates?: Maybe<Scalars['jsonb']>;
  country?: Maybe<Scalars['String']>;
  /** An array relationship */
  descriptions: Array<Descriptions>;
  /** An object relationship */
  detail?: Maybe<Detail>;
  /** An object relationship */
  furnishingProposals?: Maybe<Furnishing_Proposals>;
  id: Scalars['uuid'];
  insertedAt: Scalars['timestamp'];
  /** An array relationship */
  photos: Array<Photos>;
  /** An object relationship */
  planimetries?: Maybe<Planimetries>;
  /** An array relationship */
  pointsOfInterest: Array<Points_Of_Interest>;
  /** An array relationship */
  publicUrls: Array<Public_Urls>;
  publishedAt?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  residentialType?: Maybe<Scalars['String']>;
  /** An object relationship */
  services?: Maybe<Services>;
  showStreetNumber?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  /** An object relationship */
  virtualTours?: Maybe<Virtual_Tours>;
};


/** columns and relationships of "listings_detail" */
export type Listings_DetailCoordinatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "listings_detail" */
export type Listings_DetailDescriptionsArgs = {
  distinct_on?: InputMaybe<Array<Descriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Descriptions_Order_By>>;
  where?: InputMaybe<Descriptions_Bool_Exp>;
};


/** columns and relationships of "listings_detail" */
export type Listings_DetailPhotosArgs = {
  distinct_on?: InputMaybe<Array<Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Photos_Order_By>>;
  where?: InputMaybe<Photos_Bool_Exp>;
};


/** columns and relationships of "listings_detail" */
export type Listings_DetailPointsOfInterestArgs = {
  distinct_on?: InputMaybe<Array<Points_Of_Interest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Points_Of_Interest_Order_By>>;
  where?: InputMaybe<Points_Of_Interest_Bool_Exp>;
};


/** columns and relationships of "listings_detail" */
export type Listings_DetailPublicUrlsArgs = {
  distinct_on?: InputMaybe<Array<Public_Urls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Public_Urls_Order_By>>;
  where?: InputMaybe<Public_Urls_Bool_Exp>;
};

/** aggregated selection of "listings_detail" */
export type Listings_Detail_Aggregate = {
  __typename?: 'listings_detail_aggregate';
  aggregate?: Maybe<Listings_Detail_Aggregate_Fields>;
  nodes: Array<Listings_Detail>;
};

/** aggregate fields of "listings_detail" */
export type Listings_Detail_Aggregate_Fields = {
  __typename?: 'listings_detail_aggregate_fields';
  avg?: Maybe<Listings_Detail_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Listings_Detail_Max_Fields>;
  min?: Maybe<Listings_Detail_Min_Fields>;
  stddev?: Maybe<Listings_Detail_Stddev_Fields>;
  stddev_pop?: Maybe<Listings_Detail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Listings_Detail_Stddev_Samp_Fields>;
  sum?: Maybe<Listings_Detail_Sum_Fields>;
  var_pop?: Maybe<Listings_Detail_Var_Pop_Fields>;
  var_samp?: Maybe<Listings_Detail_Var_Samp_Fields>;
  variance?: Maybe<Listings_Detail_Variance_Fields>;
};


/** aggregate fields of "listings_detail" */
export type Listings_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Listings_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "listings_detail" */
export type Listings_Detail_Aggregate_Order_By = {
  avg?: InputMaybe<Listings_Detail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Listings_Detail_Max_Order_By>;
  min?: InputMaybe<Listings_Detail_Min_Order_By>;
  stddev?: InputMaybe<Listings_Detail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Listings_Detail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Listings_Detail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Listings_Detail_Sum_Order_By>;
  var_pop?: InputMaybe<Listings_Detail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Listings_Detail_Var_Samp_Order_By>;
  variance?: InputMaybe<Listings_Detail_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Listings_Detail_Avg_Fields = {
  __typename?: 'listings_detail_avg_fields';
  ranking?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "listings_detail" */
export type Listings_Detail_Avg_Order_By = {
  ranking?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "listings_detail". All fields are combined with a logical 'AND'. */
export type Listings_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Listings_Detail_Bool_Exp>>>;
  _not?: InputMaybe<Listings_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Listings_Detail_Bool_Exp>>>;
  additionalInfo?: InputMaybe<Additional_Info_Bool_Exp>;
  addressesCate?: InputMaybe<Addresses_Bool_Exp>;
  characteristics?: InputMaybe<Characteristics_Bool_Exp>;
  contactInfo?: InputMaybe<Contact_Info_Bool_Exp>;
  coordinates?: InputMaybe<Jsonb_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  descriptions?: InputMaybe<Descriptions_Bool_Exp>;
  detail?: InputMaybe<Detail_Bool_Exp>;
  furnishingProposals?: InputMaybe<Furnishing_Proposals_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  insertedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  photos?: InputMaybe<Photos_Bool_Exp>;
  planimetries?: InputMaybe<Planimetries_Bool_Exp>;
  pointsOfInterest?: InputMaybe<Points_Of_Interest_Bool_Exp>;
  publicUrls?: InputMaybe<Public_Urls_Bool_Exp>;
  publishedAt?: InputMaybe<String_Comparison_Exp>;
  ranking?: InputMaybe<Int_Comparison_Exp>;
  residentialType?: InputMaybe<String_Comparison_Exp>;
  services?: InputMaybe<Services_Bool_Exp>;
  showStreetNumber?: InputMaybe<Boolean_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  virtualTours?: InputMaybe<Virtual_Tours_Bool_Exp>;
};

/** aggregate max on columns */
export type Listings_Detail_Max_Fields = {
  __typename?: 'listings_detail_max_fields';
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insertedAt?: Maybe<Scalars['timestamp']>;
  publishedAt?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  residentialType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "listings_detail" */
export type Listings_Detail_Max_Order_By = {
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insertedAt?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  residentialType?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Listings_Detail_Min_Fields = {
  __typename?: 'listings_detail_min_fields';
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insertedAt?: Maybe<Scalars['timestamp']>;
  publishedAt?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  residentialType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "listings_detail" */
export type Listings_Detail_Min_Order_By = {
  country?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insertedAt?: InputMaybe<Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  residentialType?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** ordering options when selecting data from "listings_detail" */
export type Listings_Detail_Order_By = {
  additionalInfo?: InputMaybe<Additional_Info_Order_By>;
  addressesCate?: InputMaybe<Addresses_Order_By>;
  characteristics?: InputMaybe<Characteristics_Order_By>;
  contactInfo?: InputMaybe<Contact_Info_Order_By>;
  coordinates?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  detail?: InputMaybe<Detail_Order_By>;
  furnishingProposals?: InputMaybe<Furnishing_Proposals_Order_By>;
  id?: InputMaybe<Order_By>;
  insertedAt?: InputMaybe<Order_By>;
  planimetries?: InputMaybe<Planimetries_Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  residentialType?: InputMaybe<Order_By>;
  services?: InputMaybe<Services_Order_By>;
  showStreetNumber?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  virtualTours?: InputMaybe<Virtual_Tours_Order_By>;
};

/** primary key columns input for table: "listings_detail" */
export type Listings_Detail_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "listings_detail" */
export enum Listings_Detail_Select_Column {
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  InsertedAt = 'insertedAt',
  /** column name */
  PublishedAt = 'publishedAt',
  /** column name */
  Ranking = 'ranking',
  /** column name */
  ResidentialType = 'residentialType',
  /** column name */
  ShowStreetNumber = 'showStreetNumber',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type Listings_Detail_Stddev_Fields = {
  __typename?: 'listings_detail_stddev_fields';
  ranking?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "listings_detail" */
export type Listings_Detail_Stddev_Order_By = {
  ranking?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Listings_Detail_Stddev_Pop_Fields = {
  __typename?: 'listings_detail_stddev_pop_fields';
  ranking?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "listings_detail" */
export type Listings_Detail_Stddev_Pop_Order_By = {
  ranking?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Listings_Detail_Stddev_Samp_Fields = {
  __typename?: 'listings_detail_stddev_samp_fields';
  ranking?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "listings_detail" */
export type Listings_Detail_Stddev_Samp_Order_By = {
  ranking?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Listings_Detail_Sum_Fields = {
  __typename?: 'listings_detail_sum_fields';
  ranking?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "listings_detail" */
export type Listings_Detail_Sum_Order_By = {
  ranking?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Listings_Detail_Var_Pop_Fields = {
  __typename?: 'listings_detail_var_pop_fields';
  ranking?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "listings_detail" */
export type Listings_Detail_Var_Pop_Order_By = {
  ranking?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Listings_Detail_Var_Samp_Fields = {
  __typename?: 'listings_detail_var_samp_fields';
  ranking?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "listings_detail" */
export type Listings_Detail_Var_Samp_Order_By = {
  ranking?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Listings_Detail_Variance_Fields = {
  __typename?: 'listings_detail_variance_fields';
  ranking?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "listings_detail" */
export type Listings_Detail_Variance_Order_By = {
  ranking?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in the ascending order, nulls last */
  Asc = 'asc',
  /** in the ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in the ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in the descending order, nulls first */
  Desc = 'desc',
  /** in the descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in the descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "photos" */
export type Photos = {
  __typename?: 'photos';
  isPrimary?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "photos". All fields are combined with a logical 'AND'. */
export type Photos_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Photos_Bool_Exp>>>;
  _not?: InputMaybe<Photos_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Photos_Bool_Exp>>>;
  isPrimary?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "photos" */
export type Photos_Order_By = {
  isPrimary?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "photos" */
export type Photos_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "photos" */
export enum Photos_Select_Column {
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  Order = 'order',
  /** column name */
  Url = 'url'
}

/** columns and relationships of "planimetries" */
export type Planimetries = {
  __typename?: 'planimetries';
  url?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "planimetries". All fields are combined with a logical 'AND'. */
export type Planimetries_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Planimetries_Bool_Exp>>>;
  _not?: InputMaybe<Planimetries_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Planimetries_Bool_Exp>>>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "planimetries" */
export type Planimetries_Order_By = {
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "planimetries" */
export type Planimetries_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "planimetries" */
export enum Planimetries_Select_Column {
  /** column name */
  Url = 'url'
}

/** columns and relationships of "points_of_interest" */
export type Points_Of_Interest = {
  __typename?: 'points_of_interest';
  coordinates?: Maybe<Scalars['jsonb']>;
  distance?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  poiType?: Maybe<Scalars['String']>;
};


/** columns and relationships of "points_of_interest" */
export type Points_Of_InterestCoordinatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "points_of_interest". All fields are combined with a logical 'AND'. */
export type Points_Of_Interest_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Points_Of_Interest_Bool_Exp>>>;
  _not?: InputMaybe<Points_Of_Interest_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Points_Of_Interest_Bool_Exp>>>;
  coordinates?: InputMaybe<Jsonb_Comparison_Exp>;
  distance?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  poiType?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "points_of_interest" */
export type Points_Of_Interest_Order_By = {
  coordinates?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  poiType?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "points_of_interest" */
export type Points_Of_Interest_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "points_of_interest" */
export enum Points_Of_Interest_Select_Column {
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Distance = 'distance',
  /** column name */
  Name = 'name',
  /** column name */
  PoiType = 'poiType'
}

/** columns and relationships of "potential_property" */
export type Potential_Property = {
  __typename?: 'potential_property';
  askedPrice?: Maybe<Scalars['jsonb']>;
  askedPriceInCents?: Maybe<Scalars['Int']>;
  balconies?: Maybe<Scalars['Int']>;
  bathrooms?: Maybe<Scalars['Int']>;
  boxAreas?: Maybe<Scalars['_int4']>;
  buildingFloors?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  commercialArea?: Maybe<Scalars['Int']>;
  constructionYear?: Maybe<Scalars['Int']>;
  coordinates?: Maybe<Scalars['jsonb']>;
  country?: Maybe<Scalars['String']>;
  energyRatingClass?: Maybe<Scalars['String']>;
  entranceFloor?: Maybe<Scalars['Int']>;
  estimatedListingPrice?: Maybe<Scalars['jsonb']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  firstPublishedAt?: Maybe<Scalars['timestamp']>;
  gardenArea?: Maybe<Scalars['Int']>;
  hasElevator?: Maybe<Scalars['Boolean']>;
  hasPool?: Maybe<Scalars['Boolean']>;
  heatingSystem?: Maybe<Scalars['String']>;
  insertedAt: Scalars['timestamp'];
  isPresentable: Scalars['Boolean'];
  metadata?: Maybe<Scalars['jsonb']>;
  offMarketSince?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  potentialPropertyFloors: Array<Potential_Property_Floors>;
  /** An array relationship */
  potentialPropertyMedia: Array<Potential_Property_Media>;
  refusalReasons?: Maybe<Scalars['_varchar']>;
  refusedAt?: Maybe<Scalars['timestamp']>;
  residentialType?: Maybe<Scalars['String']>;
  rooms?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  stateAtDeed?: Maybe<Scalars['String']>;
  stateOfMaintenance?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  tenant?: Maybe<Scalars['String']>;
  terraceAreas?: Maybe<Scalars['_int4']>;
  title?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamp'];
  valuation?: Maybe<Scalars['jsonb']>;
  valuationPriceInCents?: Maybe<Scalars['Int']>;
  viewDescription?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['jsonb']>;
  zoneSlug?: Maybe<Scalars['String']>;
};


/** columns and relationships of "potential_property" */
export type Potential_PropertyAskedPriceArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "potential_property" */
export type Potential_PropertyCoordinatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "potential_property" */
export type Potential_PropertyEstimatedListingPriceArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "potential_property" */
export type Potential_PropertyMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "potential_property" */
export type Potential_PropertyPotentialPropertyFloorsArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Floors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Floors_Order_By>>;
  where?: InputMaybe<Potential_Property_Floors_Bool_Exp>;
};


/** columns and relationships of "potential_property" */
export type Potential_PropertyPotentialPropertyMediaArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Media_Order_By>>;
  where?: InputMaybe<Potential_Property_Media_Bool_Exp>;
};


/** columns and relationships of "potential_property" */
export type Potential_PropertyValuationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "potential_property" */
export type Potential_PropertyZoneArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "potential_property" */
export type Potential_Property_Aggregate = {
  __typename?: 'potential_property_aggregate';
  aggregate?: Maybe<Potential_Property_Aggregate_Fields>;
  nodes: Array<Potential_Property>;
};

/** aggregate fields of "potential_property" */
export type Potential_Property_Aggregate_Fields = {
  __typename?: 'potential_property_aggregate_fields';
  avg?: Maybe<Potential_Property_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Potential_Property_Max_Fields>;
  min?: Maybe<Potential_Property_Min_Fields>;
  stddev?: Maybe<Potential_Property_Stddev_Fields>;
  stddev_pop?: Maybe<Potential_Property_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Potential_Property_Stddev_Samp_Fields>;
  sum?: Maybe<Potential_Property_Sum_Fields>;
  var_pop?: Maybe<Potential_Property_Var_Pop_Fields>;
  var_samp?: Maybe<Potential_Property_Var_Samp_Fields>;
  variance?: Maybe<Potential_Property_Variance_Fields>;
};


/** aggregate fields of "potential_property" */
export type Potential_Property_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Potential_Property_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "potential_property" */
export type Potential_Property_Aggregate_Order_By = {
  avg?: InputMaybe<Potential_Property_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Potential_Property_Max_Order_By>;
  min?: InputMaybe<Potential_Property_Min_Order_By>;
  stddev?: InputMaybe<Potential_Property_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Potential_Property_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Potential_Property_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Potential_Property_Sum_Order_By>;
  var_pop?: InputMaybe<Potential_Property_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Potential_Property_Var_Samp_Order_By>;
  variance?: InputMaybe<Potential_Property_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Potential_Property_Avg_Fields = {
  __typename?: 'potential_property_avg_fields';
  askedPriceInCents?: Maybe<Scalars['Float']>;
  balconies?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  buildingFloors?: Maybe<Scalars['Float']>;
  commercialArea?: Maybe<Scalars['Float']>;
  constructionYear?: Maybe<Scalars['Float']>;
  entranceFloor?: Maybe<Scalars['Float']>;
  gardenArea?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  valuationPriceInCents?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "potential_property" */
export type Potential_Property_Avg_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "potential_property". All fields are combined with a logical 'AND'. */
export type Potential_Property_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Potential_Property_Bool_Exp>>>;
  _not?: InputMaybe<Potential_Property_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Potential_Property_Bool_Exp>>>;
  askedPrice?: InputMaybe<Jsonb_Comparison_Exp>;
  askedPriceInCents?: InputMaybe<Int_Comparison_Exp>;
  balconies?: InputMaybe<Int_Comparison_Exp>;
  bathrooms?: InputMaybe<Int_Comparison_Exp>;
  boxAreas?: InputMaybe<_Int4_Comparison_Exp>;
  buildingFloors?: InputMaybe<Int_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  commercialArea?: InputMaybe<Int_Comparison_Exp>;
  constructionYear?: InputMaybe<Int_Comparison_Exp>;
  coordinates?: InputMaybe<Jsonb_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  energyRatingClass?: InputMaybe<String_Comparison_Exp>;
  entranceFloor?: InputMaybe<Int_Comparison_Exp>;
  estimatedListingPrice?: InputMaybe<Jsonb_Comparison_Exp>;
  expirationDate?: InputMaybe<Timestamp_Comparison_Exp>;
  firstPublishedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  gardenArea?: InputMaybe<Int_Comparison_Exp>;
  hasElevator?: InputMaybe<Boolean_Comparison_Exp>;
  hasPool?: InputMaybe<Boolean_Comparison_Exp>;
  heatingSystem?: InputMaybe<String_Comparison_Exp>;
  insertedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  isPresentable?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  offMarketSince?: InputMaybe<Timestamp_Comparison_Exp>;
  potentialPropertyFloors?: InputMaybe<Potential_Property_Floors_Bool_Exp>;
  potentialPropertyMedia?: InputMaybe<Potential_Property_Media_Bool_Exp>;
  refusalReasons?: InputMaybe<_Varchar_Comparison_Exp>;
  refusedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  residentialType?: InputMaybe<String_Comparison_Exp>;
  rooms?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  stateAtDeed?: InputMaybe<String_Comparison_Exp>;
  stateOfMaintenance?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  streetNumber?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<String_Comparison_Exp>;
  terraceAreas?: InputMaybe<_Int4_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  transactionId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  valuation?: InputMaybe<Jsonb_Comparison_Exp>;
  valuationPriceInCents?: InputMaybe<Int_Comparison_Exp>;
  viewDescription?: InputMaybe<String_Comparison_Exp>;
  zipCode?: InputMaybe<String_Comparison_Exp>;
  zone?: InputMaybe<Jsonb_Comparison_Exp>;
  zoneSlug?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "potential_property_floors" */
export type Potential_Property_Floors = {
  __typename?: 'potential_property_floors';
  buildingFloor?: Maybe<Scalars['Int']>;
  entireFloor?: Maybe<Scalars['Boolean']>;
  floorShift?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "potential_property_floors". All fields are combined with a logical 'AND'. */
export type Potential_Property_Floors_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Potential_Property_Floors_Bool_Exp>>>;
  _not?: InputMaybe<Potential_Property_Floors_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Potential_Property_Floors_Bool_Exp>>>;
  buildingFloor?: InputMaybe<Int_Comparison_Exp>;
  entireFloor?: InputMaybe<Boolean_Comparison_Exp>;
  floorShift?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "potential_property_floors" */
export type Potential_Property_Floors_Order_By = {
  buildingFloor?: InputMaybe<Order_By>;
  entireFloor?: InputMaybe<Order_By>;
  floorShift?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "potential_property_floors" */
export type Potential_Property_Floors_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "potential_property_floors" */
export enum Potential_Property_Floors_Select_Column {
  /** column name */
  BuildingFloor = 'buildingFloor',
  /** column name */
  EntireFloor = 'entireFloor',
  /** column name */
  FloorShift = 'floorShift'
}

/** aggregate max on columns */
export type Potential_Property_Max_Fields = {
  __typename?: 'potential_property_max_fields';
  askedPriceInCents?: Maybe<Scalars['Int']>;
  balconies?: Maybe<Scalars['Int']>;
  bathrooms?: Maybe<Scalars['Int']>;
  buildingFloors?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  commercialArea?: Maybe<Scalars['Int']>;
  constructionYear?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  energyRatingClass?: Maybe<Scalars['String']>;
  entranceFloor?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  firstPublishedAt?: Maybe<Scalars['timestamp']>;
  gardenArea?: Maybe<Scalars['Int']>;
  heatingSystem?: Maybe<Scalars['String']>;
  insertedAt?: Maybe<Scalars['timestamp']>;
  offMarketSince?: Maybe<Scalars['timestamp']>;
  refusedAt?: Maybe<Scalars['timestamp']>;
  residentialType?: Maybe<Scalars['String']>;
  rooms?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  stateAtDeed?: Maybe<Scalars['String']>;
  stateOfMaintenance?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  tenant?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  valuationPriceInCents?: Maybe<Scalars['Int']>;
  viewDescription?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  zoneSlug?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "potential_property" */
export type Potential_Property_Max_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  energyRatingClass?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  firstPublishedAt?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  heatingSystem?: InputMaybe<Order_By>;
  insertedAt?: InputMaybe<Order_By>;
  offMarketSince?: InputMaybe<Order_By>;
  refusedAt?: InputMaybe<Order_By>;
  residentialType?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  stateAtDeed?: InputMaybe<Order_By>;
  stateOfMaintenance?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  streetNumber?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
  viewDescription?: InputMaybe<Order_By>;
  zipCode?: InputMaybe<Order_By>;
  zoneSlug?: InputMaybe<Order_By>;
};

/** columns and relationships of "potential_property_media" */
export type Potential_Property_Media = {
  __typename?: 'potential_property_media';
  imageCategory?: Maybe<Scalars['String']>;
  roomType?: Maybe<Scalars['String']>;
  roomTypeConfidence?: Maybe<Scalars['float8']>;
  url?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "potential_property_media". All fields are combined with a logical 'AND'. */
export type Potential_Property_Media_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Potential_Property_Media_Bool_Exp>>>;
  _not?: InputMaybe<Potential_Property_Media_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Potential_Property_Media_Bool_Exp>>>;
  imageCategory?: InputMaybe<String_Comparison_Exp>;
  roomType?: InputMaybe<String_Comparison_Exp>;
  roomTypeConfidence?: InputMaybe<Float8_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "potential_property_media" */
export type Potential_Property_Media_Order_By = {
  imageCategory?: InputMaybe<Order_By>;
  roomType?: InputMaybe<Order_By>;
  roomTypeConfidence?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "potential_property_media" */
export type Potential_Property_Media_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "potential_property_media" */
export enum Potential_Property_Media_Select_Column {
  /** column name */
  ImageCategory = 'imageCategory',
  /** column name */
  RoomType = 'roomType',
  /** column name */
  RoomTypeConfidence = 'roomTypeConfidence',
  /** column name */
  Url = 'url'
}

/** aggregate min on columns */
export type Potential_Property_Min_Fields = {
  __typename?: 'potential_property_min_fields';
  askedPriceInCents?: Maybe<Scalars['Int']>;
  balconies?: Maybe<Scalars['Int']>;
  bathrooms?: Maybe<Scalars['Int']>;
  buildingFloors?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  commercialArea?: Maybe<Scalars['Int']>;
  constructionYear?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  energyRatingClass?: Maybe<Scalars['String']>;
  entranceFloor?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  firstPublishedAt?: Maybe<Scalars['timestamp']>;
  gardenArea?: Maybe<Scalars['Int']>;
  heatingSystem?: Maybe<Scalars['String']>;
  insertedAt?: Maybe<Scalars['timestamp']>;
  offMarketSince?: Maybe<Scalars['timestamp']>;
  refusedAt?: Maybe<Scalars['timestamp']>;
  residentialType?: Maybe<Scalars['String']>;
  rooms?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  stateAtDeed?: Maybe<Scalars['String']>;
  stateOfMaintenance?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  tenant?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  valuationPriceInCents?: Maybe<Scalars['Int']>;
  viewDescription?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  zoneSlug?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "potential_property" */
export type Potential_Property_Min_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  energyRatingClass?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  firstPublishedAt?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  heatingSystem?: InputMaybe<Order_By>;
  insertedAt?: InputMaybe<Order_By>;
  offMarketSince?: InputMaybe<Order_By>;
  refusedAt?: InputMaybe<Order_By>;
  residentialType?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  stateAtDeed?: InputMaybe<Order_By>;
  stateOfMaintenance?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  streetNumber?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
  viewDescription?: InputMaybe<Order_By>;
  zipCode?: InputMaybe<Order_By>;
  zoneSlug?: InputMaybe<Order_By>;
};

/** ordering options when selecting data from "potential_property" */
export type Potential_Property_Order_By = {
  askedPrice?: InputMaybe<Order_By>;
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  boxAreas?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  coordinates?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  energyRatingClass?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  estimatedListingPrice?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  firstPublishedAt?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  hasElevator?: InputMaybe<Order_By>;
  hasPool?: InputMaybe<Order_By>;
  heatingSystem?: InputMaybe<Order_By>;
  insertedAt?: InputMaybe<Order_By>;
  isPresentable?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  offMarketSince?: InputMaybe<Order_By>;
  refusalReasons?: InputMaybe<Order_By>;
  refusedAt?: InputMaybe<Order_By>;
  residentialType?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  stateAtDeed?: InputMaybe<Order_By>;
  stateOfMaintenance?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  streetNumber?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
  terraceAreas?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  valuation?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
  viewDescription?: InputMaybe<Order_By>;
  zipCode?: InputMaybe<Order_By>;
  zone?: InputMaybe<Order_By>;
  zoneSlug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "potential_property" */
export type Potential_Property_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "potential_property" */
export enum Potential_Property_Select_Column {
  /** column name */
  AskedPrice = 'askedPrice',
  /** column name */
  AskedPriceInCents = 'askedPriceInCents',
  /** column name */
  Balconies = 'balconies',
  /** column name */
  Bathrooms = 'bathrooms',
  /** column name */
  BoxAreas = 'boxAreas',
  /** column name */
  BuildingFloors = 'buildingFloors',
  /** column name */
  City = 'city',
  /** column name */
  CommercialArea = 'commercialArea',
  /** column name */
  ConstructionYear = 'constructionYear',
  /** column name */
  Coordinates = 'coordinates',
  /** column name */
  Country = 'country',
  /** column name */
  EnergyRatingClass = 'energyRatingClass',
  /** column name */
  EntranceFloor = 'entranceFloor',
  /** column name */
  EstimatedListingPrice = 'estimatedListingPrice',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  FirstPublishedAt = 'firstPublishedAt',
  /** column name */
  GardenArea = 'gardenArea',
  /** column name */
  HasElevator = 'hasElevator',
  /** column name */
  HasPool = 'hasPool',
  /** column name */
  HeatingSystem = 'heatingSystem',
  /** column name */
  InsertedAt = 'insertedAt',
  /** column name */
  IsPresentable = 'isPresentable',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OffMarketSince = 'offMarketSince',
  /** column name */
  RefusalReasons = 'refusalReasons',
  /** column name */
  RefusedAt = 'refusedAt',
  /** column name */
  ResidentialType = 'residentialType',
  /** column name */
  Rooms = 'rooms',
  /** column name */
  Slug = 'slug',
  /** column name */
  StateAtDeed = 'stateAtDeed',
  /** column name */
  StateOfMaintenance = 'stateOfMaintenance',
  /** column name */
  Status = 'status',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'streetNumber',
  /** column name */
  Tenant = 'tenant',
  /** column name */
  TerraceAreas = 'terraceAreas',
  /** column name */
  Title = 'title',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Valuation = 'valuation',
  /** column name */
  ValuationPriceInCents = 'valuationPriceInCents',
  /** column name */
  ViewDescription = 'viewDescription',
  /** column name */
  ZipCode = 'zipCode',
  /** column name */
  Zone = 'zone',
  /** column name */
  ZoneSlug = 'zoneSlug'
}

/** aggregate stddev on columns */
export type Potential_Property_Stddev_Fields = {
  __typename?: 'potential_property_stddev_fields';
  askedPriceInCents?: Maybe<Scalars['Float']>;
  balconies?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  buildingFloors?: Maybe<Scalars['Float']>;
  commercialArea?: Maybe<Scalars['Float']>;
  constructionYear?: Maybe<Scalars['Float']>;
  entranceFloor?: Maybe<Scalars['Float']>;
  gardenArea?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  valuationPriceInCents?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "potential_property" */
export type Potential_Property_Stddev_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Potential_Property_Stddev_Pop_Fields = {
  __typename?: 'potential_property_stddev_pop_fields';
  askedPriceInCents?: Maybe<Scalars['Float']>;
  balconies?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  buildingFloors?: Maybe<Scalars['Float']>;
  commercialArea?: Maybe<Scalars['Float']>;
  constructionYear?: Maybe<Scalars['Float']>;
  entranceFloor?: Maybe<Scalars['Float']>;
  gardenArea?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  valuationPriceInCents?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "potential_property" */
export type Potential_Property_Stddev_Pop_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Potential_Property_Stddev_Samp_Fields = {
  __typename?: 'potential_property_stddev_samp_fields';
  askedPriceInCents?: Maybe<Scalars['Float']>;
  balconies?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  buildingFloors?: Maybe<Scalars['Float']>;
  commercialArea?: Maybe<Scalars['Float']>;
  constructionYear?: Maybe<Scalars['Float']>;
  entranceFloor?: Maybe<Scalars['Float']>;
  gardenArea?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  valuationPriceInCents?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "potential_property" */
export type Potential_Property_Stddev_Samp_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Potential_Property_Sum_Fields = {
  __typename?: 'potential_property_sum_fields';
  askedPriceInCents?: Maybe<Scalars['Int']>;
  balconies?: Maybe<Scalars['Int']>;
  bathrooms?: Maybe<Scalars['Int']>;
  buildingFloors?: Maybe<Scalars['Int']>;
  commercialArea?: Maybe<Scalars['Int']>;
  constructionYear?: Maybe<Scalars['Int']>;
  entranceFloor?: Maybe<Scalars['Int']>;
  gardenArea?: Maybe<Scalars['Int']>;
  rooms?: Maybe<Scalars['Int']>;
  valuationPriceInCents?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "potential_property" */
export type Potential_Property_Sum_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Potential_Property_Var_Pop_Fields = {
  __typename?: 'potential_property_var_pop_fields';
  askedPriceInCents?: Maybe<Scalars['Float']>;
  balconies?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  buildingFloors?: Maybe<Scalars['Float']>;
  commercialArea?: Maybe<Scalars['Float']>;
  constructionYear?: Maybe<Scalars['Float']>;
  entranceFloor?: Maybe<Scalars['Float']>;
  gardenArea?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  valuationPriceInCents?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "potential_property" */
export type Potential_Property_Var_Pop_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Potential_Property_Var_Samp_Fields = {
  __typename?: 'potential_property_var_samp_fields';
  askedPriceInCents?: Maybe<Scalars['Float']>;
  balconies?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  buildingFloors?: Maybe<Scalars['Float']>;
  commercialArea?: Maybe<Scalars['Float']>;
  constructionYear?: Maybe<Scalars['Float']>;
  entranceFloor?: Maybe<Scalars['Float']>;
  gardenArea?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  valuationPriceInCents?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "potential_property" */
export type Potential_Property_Var_Samp_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Potential_Property_Variance_Fields = {
  __typename?: 'potential_property_variance_fields';
  askedPriceInCents?: Maybe<Scalars['Float']>;
  balconies?: Maybe<Scalars['Float']>;
  bathrooms?: Maybe<Scalars['Float']>;
  buildingFloors?: Maybe<Scalars['Float']>;
  commercialArea?: Maybe<Scalars['Float']>;
  constructionYear?: Maybe<Scalars['Float']>;
  entranceFloor?: Maybe<Scalars['Float']>;
  gardenArea?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  valuationPriceInCents?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "potential_property" */
export type Potential_Property_Variance_Order_By = {
  askedPriceInCents?: InputMaybe<Order_By>;
  balconies?: InputMaybe<Order_By>;
  bathrooms?: InputMaybe<Order_By>;
  buildingFloors?: InputMaybe<Order_By>;
  commercialArea?: InputMaybe<Order_By>;
  constructionYear?: InputMaybe<Order_By>;
  entranceFloor?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  valuationPriceInCents?: InputMaybe<Order_By>;
};

/** columns and relationships of "public_urls" */
export type Public_Urls = {
  __typename?: 'public_urls';
  language?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "public_urls". All fields are combined with a logical 'AND'. */
export type Public_Urls_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Public_Urls_Bool_Exp>>>;
  _not?: InputMaybe<Public_Urls_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Public_Urls_Bool_Exp>>>;
  language?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "public_urls" */
export type Public_Urls_Order_By = {
  language?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "public_urls" */
export type Public_Urls_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "public_urls" */
export enum Public_Urls_Select_Column {
  /** column name */
  Language = 'language',
  /** column name */
  Url = 'url'
}

/** query root */
export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "additional_info" using primary key columns */
  additional_info_by_pk?: Maybe<Additional_Info>;
  /** fetch data from the table: "additional_info" */
  additional_info_cate: Array<Additional_Info>;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** fetch data from the table: "addresses" */
  addresses_cate: Array<Addresses>;
  /** fetch data from the table: "balconies" using primary key columns */
  balconies_by_pk?: Maybe<Balconies>;
  /** fetch data from the table: "balconies" */
  balconies_cate: Array<Balconies>;
  /** fetch data from the table: "boxes" */
  box_cate: Array<Boxes>;
  /** fetch data from the table: "boxes" using primary key columns */
  boxes_by_pk?: Maybe<Boxes>;
  /** fetch data from the table: "characteristics" using primary key columns */
  characteristics_by_pk?: Maybe<Characteristics>;
  /** fetch data from the table: "characteristics" */
  characteristics_cate: Array<Characteristics>;
  /** fetch data from the table: "cities" using primary key columns */
  cities_by_pk?: Maybe<Cities>;
  /** fetch data from the table: "cities" */
  cities_cate: Array<Cities>;
  /** fetch data from the table: "city_zones" */
  cities_zones_cate: Array<City_Zones>;
  /** fetch data from the table: "city_zones" using primary key columns */
  city_zones_by_pk?: Maybe<City_Zones>;
  /** fetch data from the table: "condo_fees_per_year" using primary key columns */
  condo_fees_per_year_by_pk?: Maybe<Condo_Fees_Per_Year>;
  /** fetch data from the table: "condo_fees_per_year" */
  condo_fees_per_year_cate: Array<Condo_Fees_Per_Year>;
  /** fetch data from the table: "contact_info" using primary key columns */
  contact_info_by_pk?: Maybe<Contact_Info>;
  /** fetch data from the table: "contact_info" */
  contact_info_cate: Array<Contact_Info>;
  /** fetch data from the table: "descriptions" using primary key columns */
  descriptions_by_pk?: Maybe<Descriptions>;
  /** fetch data from the table: "descriptions" */
  descriptions_cate: Array<Descriptions>;
  /** fetch data from the table: "detail" using primary key columns */
  detail_by_pk?: Maybe<Detail>;
  /** fetch data from the table: "detail" */
  detail_cate: Array<Detail>;
  /** fetch data from the table: "floors" using primary key columns */
  floors_by_pk?: Maybe<Floors>;
  /** fetch data from the table: "floors" */
  floors_cate: Array<Floors>;
  /** fetch data from the table: "furnishing_proposals" using primary key columns */
  furnishing_proposals_by_pk?: Maybe<Furnishing_Proposals>;
  /** fetch data from the table: "furnishing_proposals" */
  furnishing_proposals_cate: Array<Furnishing_Proposals>;
  /** fetch data from the table: "listings_detail" */
  listingsDetailCate: Array<Listings_Detail>;
  /** fetch aggregated fields from the table: "listings_detail" */
  listings_detail_aggregate: Listings_Detail_Aggregate;
  /** fetch data from the table: "listings_detail" using primary key columns */
  listings_detail_by_pk?: Maybe<Listings_Detail>;
  /** fetch data from the table: "photos" using primary key columns */
  photos_by_pk?: Maybe<Photos>;
  /** fetch data from the table: "photos" */
  photos_cate: Array<Photos>;
  /** fetch data from the table: "planimetries" using primary key columns */
  planimetries_by_pk?: Maybe<Planimetries>;
  /** fetch data from the table: "planimetries" */
  planimetries_cate: Array<Planimetries>;
  /** fetch data from the table: "points_of_interest" using primary key columns */
  points_of_interest_by_pk?: Maybe<Points_Of_Interest>;
  /** fetch data from the table: "points_of_interest" */
  points_of_interest_cate: Array<Points_Of_Interest>;
  /** fetch data from the table: "potential_property" */
  potential_property: Array<Potential_Property>;
  /** fetch aggregated fields from the table: "potential_property" */
  potential_property_aggregate: Potential_Property_Aggregate;
  /** fetch data from the table: "potential_property" using primary key columns */
  potential_property_by_pk?: Maybe<Potential_Property>;
  /** fetch data from the table: "potential_property_floors" */
  potential_property_floors: Array<Potential_Property_Floors>;
  /** fetch data from the table: "potential_property_floors" using primary key columns */
  potential_property_floors_by_pk?: Maybe<Potential_Property_Floors>;
  /** fetch data from the table: "potential_property_media" */
  potential_property_media: Array<Potential_Property_Media>;
  /** fetch data from the table: "potential_property_media" using primary key columns */
  potential_property_media_by_pk?: Maybe<Potential_Property_Media>;
  /** fetch data from the table: "public_urls" using primary key columns */
  public_urls_by_pk?: Maybe<Public_Urls>;
  /** fetch data from the table: "public_urls" */
  public_urls_cate: Array<Public_Urls>;
  /** fetch data from the table: "selling_prices" */
  sellingPricesCate: Array<Selling_Prices>;
  /** fetch data from the table: "selling_prices" using primary key columns */
  selling_prices_by_pk?: Maybe<Selling_Prices>;
  /** fetch data from the table: "services" using primary key columns */
  services_by_pk?: Maybe<Services>;
  /** fetch data from the table: "services" */
  services_cate: Array<Services>;
  /** fetch data from the table: "terraces" using primary key columns */
  terraces_by_pk?: Maybe<Terraces>;
  /** fetch data from the table: "terraces" */
  terraces_cate: Array<Terraces>;
  /** fetch data from the table: "titles" using primary key columns */
  titles_by_pk?: Maybe<Titles>;
  /** fetch data from the table: "titles" */
  titles_cate: Array<Titles>;
  /** fetch data from the table: "translations" using primary key columns */
  translations_by_pk?: Maybe<Translations>;
  /** fetch data from the table: "translations" */
  translations_cate: Array<Translations>;
  /** fetch data from the table: "virtual_tours" using primary key columns */
  virtual_tours_by_pk?: Maybe<Virtual_Tours>;
  /** fetch data from the table: "virtual_tours" */
  virtual_tours_cate: Array<Virtual_Tours>;
  /** fetch data from the table: "zones" using primary key columns */
  zones_by_pk?: Maybe<Zones>;
  /** fetch data from the table: "zones" */
  zones_cate: Array<Zones>;
};


/** query root */
export type Query_RootAdditional_Info_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootAdditional_Info_CateArgs = {
  distinct_on?: InputMaybe<Array<Additional_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Additional_Info_Order_By>>;
  where?: InputMaybe<Additional_Info_Bool_Exp>;
};


/** query root */
export type Query_RootAddresses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootAddresses_CateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


/** query root */
export type Query_RootBalconies_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootBalconies_CateArgs = {
  distinct_on?: InputMaybe<Array<Balconies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Balconies_Order_By>>;
  where?: InputMaybe<Balconies_Bool_Exp>;
};


/** query root */
export type Query_RootBox_CateArgs = {
  distinct_on?: InputMaybe<Array<Boxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Boxes_Order_By>>;
  where?: InputMaybe<Boxes_Bool_Exp>;
};


/** query root */
export type Query_RootBoxes_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootCharacteristics_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootCharacteristics_CateArgs = {
  distinct_on?: InputMaybe<Array<Characteristics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Characteristics_Order_By>>;
  where?: InputMaybe<Characteristics_Bool_Exp>;
};


/** query root */
export type Query_RootCities_By_PkArgs = {
  id: Scalars['String'];
};


/** query root */
export type Query_RootCities_CateArgs = {
  distinct_on?: InputMaybe<Array<Cities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cities_Order_By>>;
  where?: InputMaybe<Cities_Bool_Exp>;
};


/** query root */
export type Query_RootCities_Zones_CateArgs = {
  distinct_on?: InputMaybe<Array<City_Zones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Zones_Order_By>>;
  where?: InputMaybe<City_Zones_Bool_Exp>;
};


/** query root */
export type Query_RootCity_Zones_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootCondo_Fees_Per_Year_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootCondo_Fees_Per_Year_CateArgs = {
  distinct_on?: InputMaybe<Array<Condo_Fees_Per_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Condo_Fees_Per_Year_Order_By>>;
  where?: InputMaybe<Condo_Fees_Per_Year_Bool_Exp>;
};


/** query root */
export type Query_RootContact_Info_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootContact_Info_CateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Info_Order_By>>;
  where?: InputMaybe<Contact_Info_Bool_Exp>;
};


/** query root */
export type Query_RootDescriptions_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootDescriptions_CateArgs = {
  distinct_on?: InputMaybe<Array<Descriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Descriptions_Order_By>>;
  where?: InputMaybe<Descriptions_Bool_Exp>;
};


/** query root */
export type Query_RootDetail_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootDetail_CateArgs = {
  distinct_on?: InputMaybe<Array<Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detail_Order_By>>;
  where?: InputMaybe<Detail_Bool_Exp>;
};


/** query root */
export type Query_RootFloors_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootFloors_CateArgs = {
  distinct_on?: InputMaybe<Array<Floors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Floors_Order_By>>;
  where?: InputMaybe<Floors_Bool_Exp>;
};


/** query root */
export type Query_RootFurnishing_Proposals_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootFurnishing_Proposals_CateArgs = {
  distinct_on?: InputMaybe<Array<Furnishing_Proposals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Furnishing_Proposals_Order_By>>;
  where?: InputMaybe<Furnishing_Proposals_Bool_Exp>;
};


/** query root */
export type Query_RootListingsDetailCateArgs = {
  distinct_on?: InputMaybe<Array<Listings_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listings_Detail_Order_By>>;
  where?: InputMaybe<Listings_Detail_Bool_Exp>;
};


/** query root */
export type Query_RootListings_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Listings_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listings_Detail_Order_By>>;
  where?: InputMaybe<Listings_Detail_Bool_Exp>;
};


/** query root */
export type Query_RootListings_Detail_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPhotos_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootPhotos_CateArgs = {
  distinct_on?: InputMaybe<Array<Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Photos_Order_By>>;
  where?: InputMaybe<Photos_Bool_Exp>;
};


/** query root */
export type Query_RootPlanimetries_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootPlanimetries_CateArgs = {
  distinct_on?: InputMaybe<Array<Planimetries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planimetries_Order_By>>;
  where?: InputMaybe<Planimetries_Bool_Exp>;
};


/** query root */
export type Query_RootPoints_Of_Interest_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootPoints_Of_Interest_CateArgs = {
  distinct_on?: InputMaybe<Array<Points_Of_Interest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Points_Of_Interest_Order_By>>;
  where?: InputMaybe<Points_Of_Interest_Bool_Exp>;
};


/** query root */
export type Query_RootPotential_PropertyArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Order_By>>;
  where?: InputMaybe<Potential_Property_Bool_Exp>;
};


/** query root */
export type Query_RootPotential_Property_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Order_By>>;
  where?: InputMaybe<Potential_Property_Bool_Exp>;
};


/** query root */
export type Query_RootPotential_Property_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootPotential_Property_FloorsArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Floors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Floors_Order_By>>;
  where?: InputMaybe<Potential_Property_Floors_Bool_Exp>;
};


/** query root */
export type Query_RootPotential_Property_Floors_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootPotential_Property_MediaArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Media_Order_By>>;
  where?: InputMaybe<Potential_Property_Media_Bool_Exp>;
};


/** query root */
export type Query_RootPotential_Property_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootPublic_Urls_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootPublic_Urls_CateArgs = {
  distinct_on?: InputMaybe<Array<Public_Urls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Public_Urls_Order_By>>;
  where?: InputMaybe<Public_Urls_Bool_Exp>;
};


/** query root */
export type Query_RootSellingPricesCateArgs = {
  distinct_on?: InputMaybe<Array<Selling_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selling_Prices_Order_By>>;
  where?: InputMaybe<Selling_Prices_Bool_Exp>;
};


/** query root */
export type Query_RootSelling_Prices_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootServices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootServices_CateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


/** query root */
export type Query_RootTerraces_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootTerraces_CateArgs = {
  distinct_on?: InputMaybe<Array<Terraces_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Terraces_Order_By>>;
  where?: InputMaybe<Terraces_Bool_Exp>;
};


/** query root */
export type Query_RootTitles_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootTitles_CateArgs = {
  distinct_on?: InputMaybe<Array<Titles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Titles_Order_By>>;
  where?: InputMaybe<Titles_Bool_Exp>;
};


/** query root */
export type Query_RootTranslations_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootTranslations_CateArgs = {
  distinct_on?: InputMaybe<Array<Translations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Translations_Order_By>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};


/** query root */
export type Query_RootVirtual_Tours_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootVirtual_Tours_CateArgs = {
  distinct_on?: InputMaybe<Array<Virtual_Tours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Virtual_Tours_Order_By>>;
  where?: InputMaybe<Virtual_Tours_Bool_Exp>;
};


/** query root */
export type Query_RootZones_By_PkArgs = {
  id: Scalars['bigint'];
};


/** query root */
export type Query_RootZones_CateArgs = {
  distinct_on?: InputMaybe<Array<Zones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Zones_Order_By>>;
  where?: InputMaybe<Zones_Bool_Exp>;
};

/** columns and relationships of "selling_prices" */
export type Selling_Prices = {
  __typename?: 'selling_prices';
  cents?: Maybe<Scalars['bigint']>;
  currency?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "selling_prices". All fields are combined with a logical 'AND'. */
export type Selling_Prices_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Selling_Prices_Bool_Exp>>>;
  _not?: InputMaybe<Selling_Prices_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Selling_Prices_Bool_Exp>>>;
  cents?: InputMaybe<Bigint_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "selling_prices" */
export type Selling_Prices_Order_By = {
  cents?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "selling_prices" */
export type Selling_Prices_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "selling_prices" */
export enum Selling_Prices_Select_Column {
  /** column name */
  Cents = 'cents',
  /** column name */
  Currency = 'currency'
}

/** columns and relationships of "services" */
export type Services = {
  __typename?: 'services';
  alarmSystem?: Maybe<Scalars['Boolean']>;
  armoredDoor?: Maybe<Scalars['Boolean']>;
  basement?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  box?: Maybe<Boxes>;
  conciergeService?: Maybe<Scalars['Boolean']>;
  disabledAccess?: Maybe<Scalars['Boolean']>;
  disabledFriendly?: Maybe<Scalars['Boolean']>;
  electricGate?: Maybe<Scalars['Boolean']>;
  elevator?: Maybe<Scalars['Boolean']>;
  entranceVideoPhone?: Maybe<Scalars['Boolean']>;
  fastInternet?: Maybe<Scalars['Boolean']>;
  fireplace?: Maybe<Scalars['Boolean']>;
  garden?: Maybe<Scalars['Boolean']>;
  gardenArea?: Maybe<Scalars['Int']>;
  garret?: Maybe<Scalars['Boolean']>;
  homeAutomationSystem?: Maybe<Scalars['Boolean']>;
  hydromassage?: Maybe<Scalars['Boolean']>;
  parkingSpaces?: Maybe<Scalars['Boolean']>;
  pool?: Maybe<Scalars['Boolean']>;
  recreationRoom?: Maybe<Scalars['Boolean']>;
  satelliteSystem?: Maybe<Scalars['Boolean']>;
  sharedPool?: Maybe<Scalars['Boolean']>;
  tennisCourt?: Maybe<Scalars['Boolean']>;
  tvSystem?: Maybe<Scalars['Boolean']>;
  walkingArea?: Maybe<Scalars['Int']>;
  wallCabinet?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "services". All fields are combined with a logical 'AND'. */
export type Services_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Services_Bool_Exp>>>;
  _not?: InputMaybe<Services_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Services_Bool_Exp>>>;
  alarmSystem?: InputMaybe<Boolean_Comparison_Exp>;
  armoredDoor?: InputMaybe<Boolean_Comparison_Exp>;
  basement?: InputMaybe<Boolean_Comparison_Exp>;
  box?: InputMaybe<Boxes_Bool_Exp>;
  conciergeService?: InputMaybe<Boolean_Comparison_Exp>;
  disabledAccess?: InputMaybe<Boolean_Comparison_Exp>;
  disabledFriendly?: InputMaybe<Boolean_Comparison_Exp>;
  electricGate?: InputMaybe<Boolean_Comparison_Exp>;
  elevator?: InputMaybe<Boolean_Comparison_Exp>;
  entranceVideoPhone?: InputMaybe<Boolean_Comparison_Exp>;
  fastInternet?: InputMaybe<Boolean_Comparison_Exp>;
  fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  garden?: InputMaybe<Boolean_Comparison_Exp>;
  gardenArea?: InputMaybe<Int_Comparison_Exp>;
  garret?: InputMaybe<Boolean_Comparison_Exp>;
  homeAutomationSystem?: InputMaybe<Boolean_Comparison_Exp>;
  hydromassage?: InputMaybe<Boolean_Comparison_Exp>;
  parkingSpaces?: InputMaybe<Boolean_Comparison_Exp>;
  pool?: InputMaybe<Boolean_Comparison_Exp>;
  recreationRoom?: InputMaybe<Boolean_Comparison_Exp>;
  satelliteSystem?: InputMaybe<Boolean_Comparison_Exp>;
  sharedPool?: InputMaybe<Boolean_Comparison_Exp>;
  tennisCourt?: InputMaybe<Boolean_Comparison_Exp>;
  tvSystem?: InputMaybe<Boolean_Comparison_Exp>;
  walkingArea?: InputMaybe<Int_Comparison_Exp>;
  wallCabinet?: InputMaybe<Boolean_Comparison_Exp>;
};

/** ordering options when selecting data from "services" */
export type Services_Order_By = {
  alarmSystem?: InputMaybe<Order_By>;
  armoredDoor?: InputMaybe<Order_By>;
  basement?: InputMaybe<Order_By>;
  box?: InputMaybe<Boxes_Order_By>;
  conciergeService?: InputMaybe<Order_By>;
  disabledAccess?: InputMaybe<Order_By>;
  disabledFriendly?: InputMaybe<Order_By>;
  electricGate?: InputMaybe<Order_By>;
  elevator?: InputMaybe<Order_By>;
  entranceVideoPhone?: InputMaybe<Order_By>;
  fastInternet?: InputMaybe<Order_By>;
  fireplace?: InputMaybe<Order_By>;
  garden?: InputMaybe<Order_By>;
  gardenArea?: InputMaybe<Order_By>;
  garret?: InputMaybe<Order_By>;
  homeAutomationSystem?: InputMaybe<Order_By>;
  hydromassage?: InputMaybe<Order_By>;
  parkingSpaces?: InputMaybe<Order_By>;
  pool?: InputMaybe<Order_By>;
  recreationRoom?: InputMaybe<Order_By>;
  satelliteSystem?: InputMaybe<Order_By>;
  sharedPool?: InputMaybe<Order_By>;
  tennisCourt?: InputMaybe<Order_By>;
  tvSystem?: InputMaybe<Order_By>;
  walkingArea?: InputMaybe<Order_By>;
  wallCabinet?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "services" */
export type Services_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "services" */
export enum Services_Select_Column {
  /** column name */
  AlarmSystem = 'alarmSystem',
  /** column name */
  ArmoredDoor = 'armoredDoor',
  /** column name */
  Basement = 'basement',
  /** column name */
  ConciergeService = 'conciergeService',
  /** column name */
  DisabledAccess = 'disabledAccess',
  /** column name */
  DisabledFriendly = 'disabledFriendly',
  /** column name */
  ElectricGate = 'electricGate',
  /** column name */
  Elevator = 'elevator',
  /** column name */
  EntranceVideoPhone = 'entranceVideoPhone',
  /** column name */
  FastInternet = 'fastInternet',
  /** column name */
  Fireplace = 'fireplace',
  /** column name */
  Garden = 'garden',
  /** column name */
  GardenArea = 'gardenArea',
  /** column name */
  Garret = 'garret',
  /** column name */
  HomeAutomationSystem = 'homeAutomationSystem',
  /** column name */
  Hydromassage = 'hydromassage',
  /** column name */
  ParkingSpaces = 'parkingSpaces',
  /** column name */
  Pool = 'pool',
  /** column name */
  RecreationRoom = 'recreationRoom',
  /** column name */
  SatelliteSystem = 'satelliteSystem',
  /** column name */
  SharedPool = 'sharedPool',
  /** column name */
  TennisCourt = 'tennisCourt',
  /** column name */
  TvSystem = 'tvSystem',
  /** column name */
  WalkingArea = 'walkingArea',
  /** column name */
  WallCabinet = 'wallCabinet'
}

/** subscription root */
export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "additional_info" using primary key columns */
  additional_info_by_pk?: Maybe<Additional_Info>;
  /** fetch data from the table: "additional_info" */
  additional_info_cate: Array<Additional_Info>;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** fetch data from the table: "addresses" */
  addresses_cate: Array<Addresses>;
  /** fetch data from the table: "balconies" using primary key columns */
  balconies_by_pk?: Maybe<Balconies>;
  /** fetch data from the table: "balconies" */
  balconies_cate: Array<Balconies>;
  /** fetch data from the table: "boxes" */
  box_cate: Array<Boxes>;
  /** fetch data from the table: "boxes" using primary key columns */
  boxes_by_pk?: Maybe<Boxes>;
  /** fetch data from the table: "characteristics" using primary key columns */
  characteristics_by_pk?: Maybe<Characteristics>;
  /** fetch data from the table: "characteristics" */
  characteristics_cate: Array<Characteristics>;
  /** fetch data from the table: "cities" using primary key columns */
  cities_by_pk?: Maybe<Cities>;
  /** fetch data from the table: "cities" */
  cities_cate: Array<Cities>;
  /** fetch data from the table: "city_zones" */
  cities_zones_cate: Array<City_Zones>;
  /** fetch data from the table: "city_zones" using primary key columns */
  city_zones_by_pk?: Maybe<City_Zones>;
  /** fetch data from the table: "condo_fees_per_year" using primary key columns */
  condo_fees_per_year_by_pk?: Maybe<Condo_Fees_Per_Year>;
  /** fetch data from the table: "condo_fees_per_year" */
  condo_fees_per_year_cate: Array<Condo_Fees_Per_Year>;
  /** fetch data from the table: "contact_info" using primary key columns */
  contact_info_by_pk?: Maybe<Contact_Info>;
  /** fetch data from the table: "contact_info" */
  contact_info_cate: Array<Contact_Info>;
  /** fetch data from the table: "descriptions" using primary key columns */
  descriptions_by_pk?: Maybe<Descriptions>;
  /** fetch data from the table: "descriptions" */
  descriptions_cate: Array<Descriptions>;
  /** fetch data from the table: "detail" using primary key columns */
  detail_by_pk?: Maybe<Detail>;
  /** fetch data from the table: "detail" */
  detail_cate: Array<Detail>;
  /** fetch data from the table: "floors" using primary key columns */
  floors_by_pk?: Maybe<Floors>;
  /** fetch data from the table: "floors" */
  floors_cate: Array<Floors>;
  /** fetch data from the table: "furnishing_proposals" using primary key columns */
  furnishing_proposals_by_pk?: Maybe<Furnishing_Proposals>;
  /** fetch data from the table: "furnishing_proposals" */
  furnishing_proposals_cate: Array<Furnishing_Proposals>;
  /** fetch data from the table: "listings_detail" */
  listingsDetailCate: Array<Listings_Detail>;
  /** fetch aggregated fields from the table: "listings_detail" */
  listings_detail_aggregate: Listings_Detail_Aggregate;
  /** fetch data from the table: "listings_detail" using primary key columns */
  listings_detail_by_pk?: Maybe<Listings_Detail>;
  /** fetch data from the table: "photos" using primary key columns */
  photos_by_pk?: Maybe<Photos>;
  /** fetch data from the table: "photos" */
  photos_cate: Array<Photos>;
  /** fetch data from the table: "planimetries" using primary key columns */
  planimetries_by_pk?: Maybe<Planimetries>;
  /** fetch data from the table: "planimetries" */
  planimetries_cate: Array<Planimetries>;
  /** fetch data from the table: "points_of_interest" using primary key columns */
  points_of_interest_by_pk?: Maybe<Points_Of_Interest>;
  /** fetch data from the table: "points_of_interest" */
  points_of_interest_cate: Array<Points_Of_Interest>;
  /** fetch data from the table: "potential_property" */
  potential_property: Array<Potential_Property>;
  /** fetch aggregated fields from the table: "potential_property" */
  potential_property_aggregate: Potential_Property_Aggregate;
  /** fetch data from the table: "potential_property" using primary key columns */
  potential_property_by_pk?: Maybe<Potential_Property>;
  /** fetch data from the table: "potential_property_floors" */
  potential_property_floors: Array<Potential_Property_Floors>;
  /** fetch data from the table: "potential_property_floors" using primary key columns */
  potential_property_floors_by_pk?: Maybe<Potential_Property_Floors>;
  /** fetch data from the table: "potential_property_media" */
  potential_property_media: Array<Potential_Property_Media>;
  /** fetch data from the table: "potential_property_media" using primary key columns */
  potential_property_media_by_pk?: Maybe<Potential_Property_Media>;
  /** fetch data from the table: "public_urls" using primary key columns */
  public_urls_by_pk?: Maybe<Public_Urls>;
  /** fetch data from the table: "public_urls" */
  public_urls_cate: Array<Public_Urls>;
  /** fetch data from the table: "selling_prices" */
  sellingPricesCate: Array<Selling_Prices>;
  /** fetch data from the table: "selling_prices" using primary key columns */
  selling_prices_by_pk?: Maybe<Selling_Prices>;
  /** fetch data from the table: "services" using primary key columns */
  services_by_pk?: Maybe<Services>;
  /** fetch data from the table: "services" */
  services_cate: Array<Services>;
  /** fetch data from the table: "terraces" using primary key columns */
  terraces_by_pk?: Maybe<Terraces>;
  /** fetch data from the table: "terraces" */
  terraces_cate: Array<Terraces>;
  /** fetch data from the table: "titles" using primary key columns */
  titles_by_pk?: Maybe<Titles>;
  /** fetch data from the table: "titles" */
  titles_cate: Array<Titles>;
  /** fetch data from the table: "translations" using primary key columns */
  translations_by_pk?: Maybe<Translations>;
  /** fetch data from the table: "translations" */
  translations_cate: Array<Translations>;
  /** fetch data from the table: "virtual_tours" using primary key columns */
  virtual_tours_by_pk?: Maybe<Virtual_Tours>;
  /** fetch data from the table: "virtual_tours" */
  virtual_tours_cate: Array<Virtual_Tours>;
  /** fetch data from the table: "zones" using primary key columns */
  zones_by_pk?: Maybe<Zones>;
  /** fetch data from the table: "zones" */
  zones_cate: Array<Zones>;
};


/** subscription root */
export type Subscription_RootAdditional_Info_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootAdditional_Info_CateArgs = {
  distinct_on?: InputMaybe<Array<Additional_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Additional_Info_Order_By>>;
  where?: InputMaybe<Additional_Info_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAddresses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootAddresses_CateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBalconies_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootBalconies_CateArgs = {
  distinct_on?: InputMaybe<Array<Balconies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Balconies_Order_By>>;
  where?: InputMaybe<Balconies_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBox_CateArgs = {
  distinct_on?: InputMaybe<Array<Boxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Boxes_Order_By>>;
  where?: InputMaybe<Boxes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBoxes_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootCharacteristics_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootCharacteristics_CateArgs = {
  distinct_on?: InputMaybe<Array<Characteristics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Characteristics_Order_By>>;
  where?: InputMaybe<Characteristics_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCities_By_PkArgs = {
  id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootCities_CateArgs = {
  distinct_on?: InputMaybe<Array<Cities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cities_Order_By>>;
  where?: InputMaybe<Cities_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCities_Zones_CateArgs = {
  distinct_on?: InputMaybe<Array<City_Zones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<City_Zones_Order_By>>;
  where?: InputMaybe<City_Zones_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCity_Zones_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootCondo_Fees_Per_Year_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootCondo_Fees_Per_Year_CateArgs = {
  distinct_on?: InputMaybe<Array<Condo_Fees_Per_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Condo_Fees_Per_Year_Order_By>>;
  where?: InputMaybe<Condo_Fees_Per_Year_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootContact_Info_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootContact_Info_CateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Info_Order_By>>;
  where?: InputMaybe<Contact_Info_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDescriptions_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootDescriptions_CateArgs = {
  distinct_on?: InputMaybe<Array<Descriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Descriptions_Order_By>>;
  where?: InputMaybe<Descriptions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDetail_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootDetail_CateArgs = {
  distinct_on?: InputMaybe<Array<Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detail_Order_By>>;
  where?: InputMaybe<Detail_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFloors_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootFloors_CateArgs = {
  distinct_on?: InputMaybe<Array<Floors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Floors_Order_By>>;
  where?: InputMaybe<Floors_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFurnishing_Proposals_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootFurnishing_Proposals_CateArgs = {
  distinct_on?: InputMaybe<Array<Furnishing_Proposals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Furnishing_Proposals_Order_By>>;
  where?: InputMaybe<Furnishing_Proposals_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootListingsDetailCateArgs = {
  distinct_on?: InputMaybe<Array<Listings_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listings_Detail_Order_By>>;
  where?: InputMaybe<Listings_Detail_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootListings_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Listings_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Listings_Detail_Order_By>>;
  where?: InputMaybe<Listings_Detail_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootListings_Detail_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPhotos_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootPhotos_CateArgs = {
  distinct_on?: InputMaybe<Array<Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Photos_Order_By>>;
  where?: InputMaybe<Photos_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPlanimetries_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootPlanimetries_CateArgs = {
  distinct_on?: InputMaybe<Array<Planimetries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planimetries_Order_By>>;
  where?: InputMaybe<Planimetries_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPoints_Of_Interest_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootPoints_Of_Interest_CateArgs = {
  distinct_on?: InputMaybe<Array<Points_Of_Interest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Points_Of_Interest_Order_By>>;
  where?: InputMaybe<Points_Of_Interest_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPotential_PropertyArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Order_By>>;
  where?: InputMaybe<Potential_Property_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPotential_Property_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Order_By>>;
  where?: InputMaybe<Potential_Property_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPotential_Property_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootPotential_Property_FloorsArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Floors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Floors_Order_By>>;
  where?: InputMaybe<Potential_Property_Floors_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPotential_Property_Floors_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootPotential_Property_MediaArgs = {
  distinct_on?: InputMaybe<Array<Potential_Property_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Potential_Property_Media_Order_By>>;
  where?: InputMaybe<Potential_Property_Media_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPotential_Property_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootPublic_Urls_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootPublic_Urls_CateArgs = {
  distinct_on?: InputMaybe<Array<Public_Urls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Public_Urls_Order_By>>;
  where?: InputMaybe<Public_Urls_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSellingPricesCateArgs = {
  distinct_on?: InputMaybe<Array<Selling_Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selling_Prices_Order_By>>;
  where?: InputMaybe<Selling_Prices_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSelling_Prices_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootServices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootServices_CateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTerraces_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootTerraces_CateArgs = {
  distinct_on?: InputMaybe<Array<Terraces_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Terraces_Order_By>>;
  where?: InputMaybe<Terraces_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTitles_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootTitles_CateArgs = {
  distinct_on?: InputMaybe<Array<Titles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Titles_Order_By>>;
  where?: InputMaybe<Titles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTranslations_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootTranslations_CateArgs = {
  distinct_on?: InputMaybe<Array<Translations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Translations_Order_By>>;
  where?: InputMaybe<Translations_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVirtual_Tours_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootVirtual_Tours_CateArgs = {
  distinct_on?: InputMaybe<Array<Virtual_Tours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Virtual_Tours_Order_By>>;
  where?: InputMaybe<Virtual_Tours_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootZones_By_PkArgs = {
  id: Scalars['bigint'];
};


/** subscription root */
export type Subscription_RootZones_CateArgs = {
  distinct_on?: InputMaybe<Array<Zones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Zones_Order_By>>;
  where?: InputMaybe<Zones_Bool_Exp>;
};

/** columns and relationships of "terraces" */
export type Terraces = {
  __typename?: 'terraces';
  area?: Maybe<Scalars['Int']>;
  areas?: Maybe<Scalars['jsonb']>;
  counter?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "terraces" */
export type TerracesAreasArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "terraces". All fields are combined with a logical 'AND'. */
export type Terraces_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Terraces_Bool_Exp>>>;
  _not?: InputMaybe<Terraces_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Terraces_Bool_Exp>>>;
  area?: InputMaybe<Int_Comparison_Exp>;
  areas?: InputMaybe<Jsonb_Comparison_Exp>;
  counter?: InputMaybe<Int_Comparison_Exp>;
};

/** ordering options when selecting data from "terraces" */
export type Terraces_Order_By = {
  area?: InputMaybe<Order_By>;
  areas?: InputMaybe<Order_By>;
  counter?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "terraces" */
export type Terraces_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "terraces" */
export enum Terraces_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  Areas = 'areas',
  /** column name */
  Counter = 'counter'
}

/** expression to compare columns of type timestamp. All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** columns and relationships of "titles" */
export type Titles = {
  __typename?: 'titles';
  language?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "titles". All fields are combined with a logical 'AND'. */
export type Titles_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Titles_Bool_Exp>>>;
  _not?: InputMaybe<Titles_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Titles_Bool_Exp>>>;
  language?: InputMaybe<String_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "titles" */
export type Titles_Order_By = {
  language?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "titles" */
export type Titles_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "titles" */
export enum Titles_Select_Column {
  /** column name */
  Language = 'language',
  /** column name */
  Text = 'text'
}

/** columns and relationships of "translations" */
export type Translations = {
  __typename?: 'translations';
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "translations". All fields are combined with a logical 'AND'. */
export type Translations_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Translations_Bool_Exp>>>;
  _not?: InputMaybe<Translations_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Translations_Bool_Exp>>>;
  language?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "translations" */
export type Translations_Order_By = {
  language?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "translations" */
export type Translations_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "translations" */
export enum Translations_Select_Column {
  /** column name */
  Language = 'language',
  /** column name */
  Value = 'value'
}

/** expression to compare columns of type uuid. All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "virtual_tours" */
export type Virtual_Tours = {
  __typename?: 'virtual_tours';
  url?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "virtual_tours". All fields are combined with a logical 'AND'. */
export type Virtual_Tours_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Virtual_Tours_Bool_Exp>>>;
  _not?: InputMaybe<Virtual_Tours_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Virtual_Tours_Bool_Exp>>>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "virtual_tours" */
export type Virtual_Tours_Order_By = {
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "virtual_tours" */
export type Virtual_Tours_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "virtual_tours" */
export enum Virtual_Tours_Select_Column {
  /** column name */
  Url = 'url'
}

/** columns and relationships of "zones" */
export type Zones = {
  __typename?: 'zones';
  label?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "zones". All fields are combined with a logical 'AND'. */
export type Zones_Bool_Exp = {
  _and?: InputMaybe<Array<InputMaybe<Zones_Bool_Exp>>>;
  _not?: InputMaybe<Zones_Bool_Exp>;
  _or?: InputMaybe<Array<InputMaybe<Zones_Bool_Exp>>>;
  label?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** ordering options when selecting data from "zones" */
export type Zones_Order_By = {
  label?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: "zones" */
export type Zones_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "zones" */
export enum Zones_Select_Column {
  /** column name */
  Label = 'label',
  /** column name */
  Slug = 'slug'
}

export type AllListingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllListingsQuery = { __typename?: 'query_root', listingsDetailCate: Array<{ __typename?: 'listings_detail', slug?: string | null, detail?: { __typename?: 'detail', city?: string | null, zone?: { __typename?: 'zones', slug?: string | null } | null } | null }> };

export type ListingBySlugAndZoneQueryVariables = Exact<{
  slug: Scalars['String'];
  zone: Scalars['String'];
}>;


export type ListingBySlugAndZoneQuery = { __typename?: 'query_root', listingsDetailCate: Array<{ __typename?: 'listings_detail', coordinates?: any | null, country?: string | null, slug?: string | null, showStreetNumber?: boolean | null, residentialType?: string | null, id: any, insertedAt: any, updatedAt: any, addressesCate?: { __typename?: 'addresses', street?: string | null, streetNumber?: string | null, zipCode?: string | null } | null, additionalInfo?: { __typename?: 'additional_info', views?: any | null, constructionYear?: number | null, condo?: boolean | null, exposure?: any | null, glazing?: string | null, furnishings?: string | null, heatingSystem?: string | null, kitchen?: string | null, lastRenovationYear?: number | null, stateAtDeed?: string | null, superCondo?: boolean | null, coolingSystem?: string | null, energyPerformanceIndex?: number | null, energyRating?: string | null, estateRegistryClass?: string | null, condoFeesPerYearCate?: { __typename?: 'condo_fees_per_year', cents?: number | null, currency?: string | null } | null } | null, descriptions: Array<{ __typename?: 'descriptions', language?: string | null, neighbourhoodDescription?: string | null, propertyDescription?: string | null }>, detail?: { __typename?: 'detail', transactionId?: string | null, sellingUnitId?: string | null, casavoDirectSale?: boolean | null, city?: string | null, commercialArea?: number | null, buildingFloors?: number | null, entireBuilding?: boolean | null, entranceFloor?: number | null, floorPosition?: any | null, exclusiveSellingMandate?: boolean | null, inventory: string, privateNegotiation?: boolean | null, salesPipeline?: string | null, floors: Array<{ __typename?: 'floors', buildingFloor?: number | null, entireFloor?: boolean | null, floorShift?: string | null }>, sellingPrices?: { __typename?: 'selling_prices', cents?: any | null, currency?: string | null } | null, titles: Array<{ __typename?: 'titles', language?: string | null, text?: string | null }>, zone?: { __typename?: 'zones', label?: string | null, slug?: string | null } | null } | null, characteristics?: { __typename?: 'characteristics', bathrooms?: number | null, bedrooms?: number | null, rooms?: number | null, stateOfMaintenance?: string | null, balconies?: { __typename?: 'balconies', area?: number | null, areas?: any | null, counter?: number | null } | null, terraces?: { __typename?: 'terraces', area?: number | null, areas?: any | null, counter?: number | null } | null } | null, contactInfo?: { __typename?: 'contact_info', agencyAddress?: string | null, agencyLogo?: string | null, agencyName?: string | null, agencyWebsite?: string | null, emailContact?: string | null, ownedByCasavo?: boolean | null, telephoneNumberContact?: string | null } | null, furnishingProposals?: { __typename?: 'furnishing_proposals', url?: string | null, price?: any | null } | null, photos: Array<{ __typename?: 'photos', isPrimary?: boolean | null, order?: number | null, url?: string | null }>, planimetries?: { __typename?: 'planimetries', url?: string | null } | null, pointsOfInterest: Array<{ __typename?: 'points_of_interest', coordinates?: any | null, distance?: number | null, name?: string | null, poiType?: string | null }>, publicUrls: Array<{ __typename?: 'public_urls', language?: string | null, url?: string | null }>, virtualTours?: { __typename?: 'virtual_tours', url?: string | null } | null, services?: { __typename?: 'services', alarmSystem?: boolean | null, armoredDoor?: boolean | null, basement?: boolean | null, conciergeService?: boolean | null, disabledAccess?: boolean | null, disabledFriendly?: boolean | null, electricGate?: boolean | null, elevator?: boolean | null, entranceVideoPhone?: boolean | null, fastInternet?: boolean | null, fireplace?: boolean | null, garden?: boolean | null, garret?: boolean | null, hydromassage?: boolean | null, parkingSpaces?: boolean | null, pool?: boolean | null, recreationRoom?: boolean | null, satelliteSystem?: boolean | null, sharedPool?: boolean | null, tennisCourt?: boolean | null, tvSystem?: boolean | null, walkingArea?: number | null, wallCabinet?: boolean | null, box?: { __typename?: 'boxes', area?: number | null, areas?: any | null, counter?: number | null } | null } | null }> };

export type FavouriteListingsDesktopQueryVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type FavouriteListingsDesktopQuery = { __typename?: 'query_root', listingsDetailCate: Array<{ __typename?: 'listings_detail', id: any, coordinates?: any | null, slug?: string | null, additionalInfo?: { __typename?: 'additional_info', energyRating?: string | null } | null, characteristics?: { __typename?: 'characteristics', bathrooms?: number | null, bedrooms?: number | null, rooms?: number | null, stateOfMaintenance?: string | null, terraces?: { __typename?: 'terraces', area?: number | null, areas?: any | null, counter?: number | null } | null } | null, contactInfo?: { __typename?: 'contact_info', agencyName?: string | null, agencyLogo?: string | null, ownedByCasavo?: boolean | null } | null, descriptions: Array<{ __typename?: 'descriptions', language?: string | null, neighbourhoodDescription?: string | null, propertyDescription?: string | null }>, detail?: { __typename?: 'detail', inventory: string, city?: string | null, commercialArea?: number | null, entranceFloor?: number | null, entireBuilding?: boolean | null, buildingFloors?: number | null, floorPosition?: any | null, sellingPrices?: { __typename?: 'selling_prices', cents?: any | null, currency?: string | null } | null, titles: Array<{ __typename?: 'titles', text?: string | null, language?: string | null }>, zone?: { __typename?: 'zones', slug?: string | null, label?: string | null } | null } | null, services?: { __typename?: 'services', garden?: boolean | null } | null, photos: Array<{ __typename?: 'photos', isPrimary?: boolean | null, url?: string | null }>, virtualTours?: { __typename?: 'virtual_tours', url?: string | null } | null }> };

export type ListingsByFilterQueryVariables = Exact<{
  where?: InputMaybe<Listings_Detail_Bool_Exp>;
  orderBy?: InputMaybe<Array<Listings_Detail_Order_By> | Listings_Detail_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ListingsByFilterQuery = { __typename?: 'query_root', listingsDetailCate: Array<{ __typename?: 'listings_detail', id: any, slug?: string | null, publishedAt?: string | null, coordinates?: any | null, additionalInfo?: { __typename?: 'additional_info', energyRating?: string | null } | null, detail?: { __typename?: 'detail', inventory: string, entranceFloor?: number | null, floorPosition?: any | null, buildingFloors?: number | null, city?: string | null, commercialArea?: number | null, entireBuilding?: boolean | null, privateNegotiation?: boolean | null, titles: Array<{ __typename?: 'titles', text?: string | null, language?: string | null }>, zone?: { __typename?: 'zones', slug?: string | null, label?: string | null } | null, sellingPrices?: { __typename?: 'selling_prices', cents?: any | null, currency?: string | null } | null } | null, contactInfo?: { __typename?: 'contact_info', ownedByCasavo?: boolean | null, agencyLogo?: string | null, agencyName?: string | null } | null, characteristics?: { __typename?: 'characteristics', bathrooms?: number | null, bedrooms?: number | null, rooms?: number | null, stateOfMaintenance?: string | null, terraces?: { __typename?: 'terraces', counter?: number | null, area?: number | null, areas?: any | null } | null } | null, services?: { __typename?: 'services', garden?: boolean | null } | null, descriptions: Array<{ __typename?: 'descriptions', propertyDescription?: string | null, neighbourhoodDescription?: string | null, language?: string | null }>, addressesCate?: { __typename?: 'addresses', street?: string | null, streetNumber?: string | null } | null, photos: Array<{ __typename?: 'photos', isPrimary?: boolean | null, order?: number | null, url?: string | null }>, virtualTours?: { __typename?: 'virtual_tours', url?: string | null } | null }>, listings_detail_aggregate: { __typename?: 'listings_detail_aggregate', aggregate?: { __typename?: 'listings_detail_aggregate_fields', count?: number | null } | null } };

export type ListingsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ListingsByIdsQuery = { __typename?: 'query_root', listingsDetailCate: Array<{ __typename?: 'listings_detail', id: any, slug?: string | null, publishedAt?: string | null, addressesCate?: { __typename?: 'addresses', street?: string | null, streetNumber?: string | null, zipCode?: string | null } | null, additionalInfo?: { __typename?: 'additional_info', energyRating?: string | null } | null, detail?: { __typename?: 'detail', entranceFloor?: number | null, buildingFloors?: number | null, casavoDirectSale?: boolean | null, city?: string | null, commercialArea?: number | null, floorPosition?: any | null, entireBuilding?: boolean | null, inventory: string, privateNegotiation?: boolean | null, sellingPrices?: { __typename?: 'selling_prices', cents?: any | null, currency?: string | null } | null, titles: Array<{ __typename?: 'titles', language?: string | null, text?: string | null }>, zone?: { __typename?: 'zones', label?: string | null, slug?: string | null } | null } | null, characteristics?: { __typename?: 'characteristics', bathrooms?: number | null, bedrooms?: number | null, rooms?: number | null, stateOfMaintenance?: string | null, terraces?: { __typename?: 'terraces', area?: number | null, areas?: any | null, counter?: number | null } | null } | null, contactInfo?: { __typename?: 'contact_info', ownedByCasavo?: boolean | null } | null, photos: Array<{ __typename?: 'photos', isPrimary?: boolean | null, order?: number | null, url?: string | null }>, virtualTours?: { __typename?: 'virtual_tours', url?: string | null } | null, services?: { __typename?: 'services', garden?: boolean | null } | null }> };

export type ListingsBySimilarQueryVariables = Exact<{
  priceMin: Scalars['bigint'];
  priceMax: Scalars['bigint'];
  areaMin: Scalars['Int'];
  areaMax: Scalars['Int'];
  roomsMin: Scalars['Int'];
  roomsMax: Scalars['Int'];
  geoSlugs: Array<Scalars['String']> | Scalars['String'];
}>;


export type ListingsBySimilarQuery = { __typename?: 'query_root', listingsDetailCate: Array<{ __typename?: 'listings_detail', id: any, coordinates?: any | null, slug?: string | null, additionalInfo?: { __typename?: 'additional_info', energyRating?: string | null } | null, characteristics?: { __typename?: 'characteristics', bathrooms?: number | null, bedrooms?: number | null, rooms?: number | null, stateOfMaintenance?: string | null, terraces?: { __typename?: 'terraces', area?: number | null, areas?: any | null, counter?: number | null } | null } | null, contactInfo?: { __typename?: 'contact_info', agencyName?: string | null, agencyLogo?: string | null, ownedByCasavo?: boolean | null } | null, descriptions: Array<{ __typename?: 'descriptions', language?: string | null, neighbourhoodDescription?: string | null, propertyDescription?: string | null }>, detail?: { __typename?: 'detail', inventory: string, city?: string | null, commercialArea?: number | null, entranceFloor?: number | null, entireBuilding?: boolean | null, buildingFloors?: number | null, floorPosition?: any | null, sellingPrices?: { __typename?: 'selling_prices', cents?: any | null, currency?: string | null } | null, titles: Array<{ __typename?: 'titles', text?: string | null, language?: string | null }>, zone?: { __typename?: 'zones', slug?: string | null, label?: string | null } | null } | null, services?: { __typename?: 'services', garden?: boolean | null } | null, photos: Array<{ __typename?: 'photos', isPrimary?: boolean | null, url?: string | null }>, virtualTours?: { __typename?: 'virtual_tours', url?: string | null } | null }> };

export type ListingsCountQueryVariables = Exact<{
  where?: InputMaybe<Listings_Detail_Bool_Exp>;
}>;


export type ListingsCountQuery = { __typename?: 'query_root', listings_detail_aggregate: { __typename?: 'listings_detail_aggregate', aggregate?: { __typename?: 'listings_detail_aggregate_fields', count?: number | null } | null } };

export type FavouriteListingsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type FavouriteListingsQuery = { __typename?: 'query_root', listingsDetailCate: Array<{ __typename?: 'listings_detail', id: any, slug?: string | null, primaryPhoto: Array<{ __typename?: 'photos', url?: string | null }>, fallbackPhoto: Array<{ __typename?: 'photos', url?: string | null }>, detail?: { __typename?: 'detail', inventory: string, commercialArea?: number | null, city?: string | null, privateNegotiation?: boolean | null, zone?: { __typename?: 'zones', slug?: string | null } | null, titles: Array<{ __typename?: 'titles', text?: string | null, language?: string | null }>, sellingPrices?: { __typename?: 'selling_prices', cents?: any | null, currency?: string | null } | null } | null, contactInfo?: { __typename?: 'contact_info', ownedByCasavo?: boolean | null } | null, additionalInfo?: { __typename?: 'additional_info', energyRating?: string | null, energyRatingCategory?: string | null } | null, photos: Array<{ __typename?: 'photos', isPrimary?: boolean | null, url?: string | null }> }> };

export type ListingsMarkerQueryVariables = Exact<{
  where?: InputMaybe<Listings_Detail_Bool_Exp>;
  orderBy?: InputMaybe<Array<Listings_Detail_Order_By> | Listings_Detail_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ListingsMarkerQuery = { __typename?: 'query_root', listingsDetailCate: Array<{ __typename?: 'listings_detail', id: any, coordinates?: any | null, contactInfo?: { __typename?: 'contact_info', ownedByCasavo?: boolean | null } | null }> };

export type PotentialPropertyByFilterQueryVariables = Exact<{
  where?: InputMaybe<Potential_Property_Bool_Exp>;
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<Potential_Property_Order_By> | Potential_Property_Order_By>;
  limit: Scalars['Int'];
}>;


export type PotentialPropertyByFilterQuery = { __typename?: 'query_root', potential_property: Array<{ __typename?: 'potential_property', transactionId?: string | null, city?: string | null, title?: string | null, slug?: string | null, rooms?: number | null, bathrooms?: number | null, stateOfMaintenance?: string | null, commercialArea?: number | null, askedPrice?: any | null, valuation?: any | null, zone?: any | null, insertedAt: any, estimatedListingPrice?: any | null, status?: string | null, energyRatingClass?: string | null, entranceFloor?: number | null, buildingFloors?: number | null, potentialPropertyMedia: Array<{ __typename?: 'potential_property_media', roomType?: string | null, url?: string | null, imageCategory?: string | null, roomTypeConfidence?: any | null }> }>, potential_property_aggregate: { __typename?: 'potential_property_aggregate', aggregate?: { __typename?: 'potential_property_aggregate_fields', count?: number | null } | null } };

export type PotentialPropertiesBySimilarQueryVariables = Exact<{
  priceMin: Scalars['Int'];
  priceMax: Scalars['Int'];
  areaMin: Scalars['Int'];
  areaMax: Scalars['Int'];
  roomsMin: Scalars['Int'];
  roomsMax: Scalars['Int'];
  geoSlugs: Array<Scalars['String']> | Scalars['String'];
}>;


export type PotentialPropertiesBySimilarQuery = { __typename?: 'query_root', potential_property: Array<{ __typename?: 'potential_property', isPresentable: boolean, askedPrice?: any | null, bathrooms?: number | null, city?: string | null, commercialArea?: number | null, estimatedListingPrice?: any | null, rooms?: number | null, slug?: string | null, stateOfMaintenance?: string | null, status?: string | null, title?: string | null, transactionId?: string | null, terraceAreas?: any | null, zone?: any | null, buildingFloors?: number | null, entranceFloor?: number | null, gardenArea?: number | null, energyRatingClass?: string | null, insertedAt: any, potentialPropertyMedia: Array<{ __typename?: 'potential_property_media', roomType?: string | null, url?: string | null, imageCategory?: string | null, roomTypeConfidence?: any | null }> }> };

export type PotentialPropertyQueryVariables = Exact<{
  slug: Scalars['String'];
  isPresentable?: InputMaybe<Scalars['Boolean']>;
}>;


export type PotentialPropertyQuery = { __typename?: 'query_root', potential_property: Array<{ __typename?: 'potential_property', transactionId?: string | null, entranceFloor?: number | null, city?: string | null, balconies?: number | null, bathrooms?: number | null, buildingFloors?: number | null, commercialArea?: number | null, constructionYear?: number | null, slug?: string | null, isPresentable: boolean, updatedAt: any, insertedAt: any, title?: string | null, askedPrice?: any | null, estimatedListingPrice?: any | null, heatingSystem?: string | null, country?: string | null, energyRatingClass?: string | null, gardenArea?: number | null, hasElevator?: boolean | null, hasPool?: boolean | null, boxAreas?: any | null, expirationDate?: any | null, stateOfMaintenance?: string | null, rooms?: number | null, valuation?: any | null, zone?: any | null, status?: string | null, potentialPropertyMedia: Array<{ __typename?: 'potential_property_media', roomType?: string | null, url?: string | null, imageCategory?: string | null, roomTypeConfidence?: any | null }>, potentialPropertyFloors: Array<{ __typename?: 'potential_property_floors', entireFloor?: boolean | null, floorShift?: string | null, buildingFloor?: number | null }> }> };

export type PotentialPropertiesBySuggestedCriteriaQueryVariables = Exact<{
  priceMax: Scalars['Int'];
  roomsMin: Scalars['Int'];
  geoSlugs: Array<Scalars['String']> | Scalars['String'];
}>;


export type PotentialPropertiesBySuggestedCriteriaQuery = { __typename?: 'query_root', potential_property: Array<{ __typename?: 'potential_property', transactionId?: string | null, entranceFloor?: number | null, city?: string | null, bathrooms?: number | null, buildingFloors?: number | null, commercialArea?: number | null, slug?: string | null, title?: string | null, energyRatingClass?: string | null, gardenArea?: number | null, stateOfMaintenance?: string | null, rooms?: number | null, terraceAreas?: any | null, askedPriceInCents?: number | null, valuationPriceInCents?: number | null, zone?: any | null, askedPrice?: any | null, valuation?: any | null, status?: string | null, estimatedListingPrice?: any | null, insertedAt: any, potentialPropertyMedia: Array<{ __typename?: 'potential_property_media', roomType?: string | null, url?: string | null, imageCategory?: string | null }> }> };


export const AllListingsDocument = gql`
    query allListings {
  listingsDetailCate {
    detail {
      city
      zone {
        slug
      }
    }
    slug
  }
}
    `;
export const ListingBySlugAndZoneDocument = gql`
    query listingBySlugAndZone($slug: String!, $zone: String!) {
  listingsDetailCate(
    where: {_and: [{slug: {_eq: $slug}}, {_or: [{detail: {zone: {slug: {_eq: $zone}}}}, {detail: {city: {_eq: $zone}}}]}]}
  ) {
    addressesCate {
      street
      streetNumber
      zipCode
    }
    additionalInfo {
      views
      constructionYear
      condo
      condoFeesPerYearCate {
        cents
        currency
      }
      exposure
      glazing
      furnishings
      heatingSystem
      kitchen
      lastRenovationYear
      stateAtDeed
      superCondo
      coolingSystem
      energyPerformanceIndex
      energyRating
      estateRegistryClass
    }
    descriptions {
      language
      neighbourhoodDescription
      propertyDescription
    }
    detail {
      transactionId
      sellingUnitId
      casavoDirectSale
      city
      commercialArea
      buildingFloors
      entireBuilding
      entranceFloor
      floorPosition
      exclusiveSellingMandate
      floors {
        buildingFloor
        entireFloor
        floorShift
      }
      inventory
      privateNegotiation
      salesPipeline
      sellingPrices {
        cents
        currency
      }
      titles {
        language
        text
      }
      zone {
        label
        slug
      }
    }
    characteristics {
      balconies {
        area
        areas
        counter
      }
      bathrooms
      bedrooms
      rooms
      stateOfMaintenance
      terraces {
        area
        areas
        counter
      }
    }
    contactInfo {
      agencyAddress
      agencyLogo
      agencyName
      agencyWebsite
      emailContact
      ownedByCasavo
      telephoneNumberContact
    }
    coordinates
    country
    furnishingProposals {
      url
      price
    }
    photos(order_by: {order: asc}) {
      isPrimary
      order
      url
    }
    planimetries {
      url
    }
    pointsOfInterest {
      coordinates
      distance
      name
      poiType
    }
    publicUrls {
      language
      url
    }
    virtualTours {
      url
    }
    services {
      alarmSystem
      armoredDoor
      basement
      box {
        area
        areas
        counter
      }
      conciergeService
      disabledAccess
      disabledFriendly
      electricGate
      elevator
      entranceVideoPhone
      fastInternet
      fireplace
      garden
      garret
      hydromassage
      parkingSpaces
      pool
      recreationRoom
      satelliteSystem
      sharedPool
      tennisCourt
      tvSystem
      walkingArea
      wallCabinet
    }
    slug
    showStreetNumber
    residentialType
    coordinates
    id
    insertedAt
    updatedAt
  }
}
    `;
export const FavouriteListingsDesktopDocument = gql`
    query favouriteListingsDesktop($ids: [uuid!]!) {
  listingsDetailCate(where: {id: {_in: $ids}}) {
    id
    coordinates
    slug
    additionalInfo {
      energyRating
    }
    characteristics {
      bathrooms
      bedrooms
      rooms
      stateOfMaintenance
      terraces {
        area
        areas
        counter
      }
    }
    contactInfo {
      agencyName
      agencyLogo
      ownedByCasavo
    }
    descriptions {
      language
      neighbourhoodDescription
      propertyDescription
    }
    detail {
      inventory
      city
      commercialArea
      entranceFloor
      entireBuilding
      buildingFloors
      floorPosition
      sellingPrices {
        cents
        currency
      }
      titles {
        text
        language
      }
      zone {
        slug
        label
      }
    }
    services {
      garden
    }
    photos {
      isPrimary
      url
    }
    virtualTours {
      url
    }
  }
}
    `;
export const ListingsByFilterDocument = gql`
    query listingsByFilter($where: listings_detail_bool_exp, $orderBy: [listings_detail_order_by!], $limit: Int, $offset: Int) {
  listingsDetailCate(
    where: $where
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    slug
    additionalInfo {
      energyRating
    }
    detail {
      inventory
      entranceFloor
      floorPosition
      titles {
        text
        language
      }
      buildingFloors
      city
      commercialArea
      entireBuilding
      privateNegotiation
      zone {
        slug
        label
      }
      sellingPrices {
        cents
        currency
      }
    }
    contactInfo {
      ownedByCasavo
      agencyLogo
      agencyName
    }
    characteristics {
      bathrooms
      bedrooms
      rooms
      stateOfMaintenance
      terraces {
        counter
        area
        areas
      }
    }
    publishedAt
    services {
      garden
    }
    descriptions {
      propertyDescription
      neighbourhoodDescription
      language
    }
    addressesCate {
      street
      streetNumber
    }
    photos(order_by: {order: asc}) {
      isPrimary
      order
      url
    }
    virtualTours {
      url
    }
    coordinates
  }
  listings_detail_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;
export const ListingsByIdsDocument = gql`
    query listingsByIds($ids: [uuid!]!) {
  listingsDetailCate(where: {id: {_in: $ids}}) {
    id
    addressesCate {
      street
      streetNumber
      zipCode
    }
    additionalInfo {
      energyRating
    }
    detail {
      sellingPrices {
        cents
        currency
      }
      entranceFloor
      buildingFloors
      casavoDirectSale
      city
      commercialArea
      floorPosition
      entireBuilding
      inventory
      privateNegotiation
      titles {
        language
        text
      }
      zone {
        label
        slug
      }
    }
    characteristics {
      bathrooms
      bedrooms
      rooms
      stateOfMaintenance
      terraces {
        area
        areas
        counter
      }
    }
    contactInfo {
      ownedByCasavo
    }
    photos(order_by: {order: asc}) {
      isPrimary
      order
      url
    }
    virtualTours {
      url
    }
    services {
      garden
    }
    slug
    publishedAt
  }
}
    `;
export const ListingsBySimilarDocument = gql`
    query listingsBySimilar($priceMin: bigint!, $priceMax: bigint!, $areaMin: Int!, $areaMax: Int!, $roomsMin: Int!, $roomsMax: Int!, $geoSlugs: [String!]!) {
  listingsDetailCate(
    where: {characteristics: {rooms: {_gte: $roomsMin, _lte: $roomsMax}}, detail: {_or: [{zone: {slug: {_in: $geoSlugs}}}, {city: {_in: $geoSlugs}}], sellingPrices: {cents: {_gte: $priceMin, _lte: $priceMax}}, commercialArea: {_gte: $areaMin, _lte: $areaMax}}}
    limit: 10
  ) {
    id
    coordinates
    slug
    additionalInfo {
      energyRating
    }
    characteristics {
      bathrooms
      bedrooms
      rooms
      stateOfMaintenance
      terraces {
        area
        areas
        counter
      }
    }
    contactInfo {
      agencyName
      agencyLogo
      ownedByCasavo
    }
    descriptions {
      language
      neighbourhoodDescription
      propertyDescription
    }
    detail {
      inventory
      city
      commercialArea
      entranceFloor
      entireBuilding
      buildingFloors
      floorPosition
      sellingPrices {
        cents
        currency
      }
      titles {
        text
        language
      }
      zone {
        slug
        label
      }
    }
    services {
      garden
    }
    photos {
      isPrimary
      url
    }
    virtualTours {
      url
    }
  }
}
    `;
export const ListingsCountDocument = gql`
    query listingsCount($where: listings_detail_bool_exp) {
  listings_detail_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;
export const FavouriteListingsDocument = gql`
    query favouriteListings($ids: [uuid!]!) {
  listingsDetailCate(where: {id: {_in: $ids}}) {
    id
    slug
    primaryPhoto: photos(limit: 1, where: {isPrimary: {_eq: true}}) {
      url
    }
    fallbackPhoto: photos(limit: 1, order_by: {order: asc}) {
      url
    }
    detail {
      inventory
      commercialArea
      city
      privateNegotiation
      zone {
        slug
      }
      titles {
        text
        language
      }
      sellingPrices {
        cents
        currency
      }
    }
    contactInfo {
      ownedByCasavo
    }
    additionalInfo {
      energyRating
      energyRatingCategory
    }
    photos {
      isPrimary
      url
    }
  }
}
    `;
export const ListingsMarkerDocument = gql`
    query listingsMarker($where: listings_detail_bool_exp, $orderBy: [listings_detail_order_by!], $limit: Int, $offset: Int) {
  listingsDetailCate(
    where: $where
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    coordinates
    contactInfo {
      ownedByCasavo
    }
  }
}
    `;
export const PotentialPropertyByFilterDocument = gql`
    query potentialPropertyByFilter($where: potential_property_bool_exp, $offset: Int!, $orderBy: [potential_property_order_by!], $limit: Int!) {
  potential_property(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    potentialPropertyMedia {
      roomType
      url
      imageCategory
      roomTypeConfidence
    }
    transactionId
    city
    title
    slug
    rooms
    bathrooms
    stateOfMaintenance
    commercialArea
    askedPrice
    valuation
    zone
    insertedAt
    estimatedListingPrice
    status
    energyRatingClass
    entranceFloor
    buildingFloors
  }
  potential_property_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;
export const PotentialPropertiesBySimilarDocument = gql`
    query potentialPropertiesBySimilar($priceMin: Int!, $priceMax: Int!, $areaMin: Int!, $areaMax: Int!, $roomsMin: Int!, $roomsMax: Int!, $geoSlugs: [String!]!) {
  potential_property(
    where: {_and: [{isPresentable: {_eq: true}}, {rooms: {_gte: $roomsMin, _lte: $roomsMax}}, {_or: [{zoneSlug: {_in: $geoSlugs}}, {city: {_in: $geoSlugs}}]}, {askedPriceInCents: {_gte: $priceMin, _lte: $priceMax}}, {commercialArea: {_gte: $areaMin, _lte: $areaMax}}]}
    limit: 10
  ) {
    isPresentable
    askedPrice
    bathrooms
    city
    commercialArea
    estimatedListingPrice
    potentialPropertyMedia {
      roomType
      url
      imageCategory
      roomTypeConfidence
    }
    rooms
    slug
    stateOfMaintenance
    status
    title
    transactionId
    terraceAreas
    zone
    buildingFloors
    entranceFloor
    gardenArea
    energyRatingClass
    insertedAt
  }
}
    `;
export const PotentialPropertyDocument = gql`
    query potentialProperty($slug: String!, $isPresentable: Boolean = true) {
  potential_property(
    where: {_and: [{slug: {_eq: $slug}}, {isPresentable: {_eq: $isPresentable}}, {title: {_is_null: false}}, {city: {_is_null: false}}, {rooms: {_is_null: false}}, {slug: {_is_null: false}}, {commercialArea: {_is_null: false}}, {bathrooms: {_is_null: false}}, {coordinates: {_is_null: false}}, {entranceFloor: {_is_null: false}}, {stateOfMaintenance: {_is_null: false}}, {residentialType: {_is_null: false}}, {_or: [{askedPrice: {_is_null: false}}, {valuation: {_is_null: false}}]}]}
  ) {
    transactionId
    entranceFloor
    city
    balconies
    bathrooms
    buildingFloors
    commercialArea
    constructionYear
    slug
    isPresentable
    updatedAt
    insertedAt
    potentialPropertyMedia {
      roomType
      url
      imageCategory
      roomTypeConfidence
    }
    title
    potentialPropertyFloors {
      entireFloor
      floorShift
      buildingFloor
    }
    askedPrice
    estimatedListingPrice
    heatingSystem
    country
    energyRatingClass
    gardenArea
    hasElevator
    hasPool
    boxAreas
    expirationDate
    stateOfMaintenance
    rooms
    valuation
    zone
    status
  }
}
    `;
export const PotentialPropertiesBySuggestedCriteriaDocument = gql`
    query potentialPropertiesBySuggestedCriteria($priceMax: Int!, $roomsMin: Int!, $geoSlugs: [String!]!) {
  potential_property(
    where: {_and: [{isPresentable: {_eq: true}}, {title: {_is_null: false}}, {slug: {_is_null: false}}, {commercialArea: {_is_null: false}}, {bathrooms: {_is_null: false}}, {coordinates: {_is_null: false}}, {entranceFloor: {_is_null: false}}, {stateOfMaintenance: {_is_null: false}}, {residentialType: {_is_null: false}}, {_or: [{zoneSlug: {_in: $geoSlugs}}, {city: {_in: $geoSlugs}}]}, {_or: [{askedPriceInCents: {_lte: $priceMax}}, {valuationPriceInCents: {_lte: $priceMax}}]}, {rooms: {_gte: $roomsMin}}]}
    limit: 20
    order_by: {firstPublishedAt: desc}
  ) {
    transactionId
    entranceFloor
    city
    bathrooms
    buildingFloors
    commercialArea
    slug
    potentialPropertyMedia {
      roomType
      url
      imageCategory
    }
    title
    energyRatingClass
    gardenArea
    stateOfMaintenance
    rooms
    terraceAreas
    askedPriceInCents
    valuationPriceInCents
    zone
    askedPrice
    valuation
    status
    estimatedListingPrice
    insertedAt
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();
const AllListingsDocumentString = print(AllListingsDocument);
const ListingBySlugAndZoneDocumentString = print(ListingBySlugAndZoneDocument);
const FavouriteListingsDesktopDocumentString = print(FavouriteListingsDesktopDocument);
const ListingsByFilterDocumentString = print(ListingsByFilterDocument);
const ListingsByIdsDocumentString = print(ListingsByIdsDocument);
const ListingsBySimilarDocumentString = print(ListingsBySimilarDocument);
const ListingsCountDocumentString = print(ListingsCountDocument);
const FavouriteListingsDocumentString = print(FavouriteListingsDocument);
const ListingsMarkerDocumentString = print(ListingsMarkerDocument);
const PotentialPropertyByFilterDocumentString = print(PotentialPropertyByFilterDocument);
const PotentialPropertiesBySimilarDocumentString = print(PotentialPropertiesBySimilarDocument);
const PotentialPropertyDocumentString = print(PotentialPropertyDocument);
const PotentialPropertiesBySuggestedCriteriaDocumentString = print(PotentialPropertiesBySuggestedCriteriaDocument);
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    allListings(variables?: AllListingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: AllListingsQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<AllListingsQuery>(AllListingsDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allListings', 'query');
    },
    listingBySlugAndZone(variables: ListingBySlugAndZoneQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: ListingBySlugAndZoneQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<ListingBySlugAndZoneQuery>(ListingBySlugAndZoneDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listingBySlugAndZone', 'query');
    },
    favouriteListingsDesktop(variables: FavouriteListingsDesktopQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: FavouriteListingsDesktopQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<FavouriteListingsDesktopQuery>(FavouriteListingsDesktopDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'favouriteListingsDesktop', 'query');
    },
    listingsByFilter(variables?: ListingsByFilterQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: ListingsByFilterQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<ListingsByFilterQuery>(ListingsByFilterDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listingsByFilter', 'query');
    },
    listingsByIds(variables: ListingsByIdsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: ListingsByIdsQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<ListingsByIdsQuery>(ListingsByIdsDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listingsByIds', 'query');
    },
    listingsBySimilar(variables: ListingsBySimilarQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: ListingsBySimilarQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<ListingsBySimilarQuery>(ListingsBySimilarDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listingsBySimilar', 'query');
    },
    listingsCount(variables?: ListingsCountQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: ListingsCountQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<ListingsCountQuery>(ListingsCountDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listingsCount', 'query');
    },
    favouriteListings(variables: FavouriteListingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: FavouriteListingsQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<FavouriteListingsQuery>(FavouriteListingsDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'favouriteListings', 'query');
    },
    listingsMarker(variables?: ListingsMarkerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: ListingsMarkerQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<ListingsMarkerQuery>(ListingsMarkerDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listingsMarker', 'query');
    },
    potentialPropertyByFilter(variables: PotentialPropertyByFilterQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: PotentialPropertyByFilterQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<PotentialPropertyByFilterQuery>(PotentialPropertyByFilterDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'potentialPropertyByFilter', 'query');
    },
    potentialPropertiesBySimilar(variables: PotentialPropertiesBySimilarQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: PotentialPropertiesBySimilarQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<PotentialPropertiesBySimilarQuery>(PotentialPropertiesBySimilarDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'potentialPropertiesBySimilar', 'query');
    },
    potentialProperty(variables: PotentialPropertyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: PotentialPropertyQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<PotentialPropertyQuery>(PotentialPropertyDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'potentialProperty', 'query');
    },
    potentialPropertiesBySuggestedCriteria(variables: PotentialPropertiesBySuggestedCriteriaQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: PotentialPropertiesBySuggestedCriteriaQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<PotentialPropertiesBySuggestedCriteriaQuery>(PotentialPropertiesBySuggestedCriteriaDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'potentialPropertiesBySuggestedCriteria', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;